import type { RomanceAfterStoryScripts } from '@/content/romanceAfterStoryTypes'

// v1.9 relationship stories remain data-only: the shared builder owns IDs, effects, replay and return safety.
// 文案基线（2026-08-05 二次重写）：
// 1. 人物在每场有自己的事要做，不是来给玩家的选择盖章；
// 2. 照顾和代价用动作和场面呈现，不用台词宣布；
// 3. 回复可以认同也可以不耐烦，但不以工整的道理句收尾，收束落在画面上；
// 4. 十二个角色的说话方式不可互换——谁先挂电话、谁嘴硬、谁把术语说漏嘴，都要看得出来。
export const romanceAfterStoryScripts = {
shana: {
    secondDate: {
      title: '半份夜宵的慢速协议',
      location: '幻想夜市 · 雨棚下的夜宵摊',
      opening: '雨棚外的灯牌被雨打得一闪一闪。夏娜只点了一份热汤和两双筷子，把其中一双拍在你面前：“第二次约会，不考你能吃多辣。先说好——今晚这顿我请，你请的那顿我要挑贵的。”',
      firstChoices: [
        {
          id: 'split-hot-soup',
          label: '把汤推到她面前：“先按你的空闲来。想吃什么，自己点。”',
          tone: 'warm',
          reply: '夏娜把辣椒碟挪远，多看了你一眼，又补了一份芋圆。“这话我以前不会当着人点。”她顿了顿，“你当没听见。”',
          styleValue: '慢慢照顾彼此',
        },
        {
          id: 'menu-by-half',
          label: '把菜单撕成两半：“各点一份。二十分钟后还想坐，就续摊。”',
          tone: 'calm',
          reply: '“可以。”夏娜勾掉共享套餐，把靠里的座位让给你，“二十分钟太少，我给你二十五。多的五分钟记账上。”',
          styleValue: '保留选择再靠近',
        },
      ],
      middle: '汤沸起来，夏娜把手机调成静音，屏幕朝下扣在桌上。你注意到要塞战报群今晚安静得反常，刚摸到自己手机——她的筷子尖在碗沿敲了一下：“敢点开，你买单。接下来，边走边聊，还是找个摊子坐到打烊？”',
      secondChoices: [
        {
          id: 'lantern-walk',
          label: '“边走边聊。累了就停，停下不算扫兴。”',
          tone: 'warm',
          reply: '夏娜把外套接过去搭在手上，没急着披。“走慢点。”她说，“今晚没人催签到。”走了两步又补一句，“……你问都不问就慢下来了，还算听话。”',
          styleValue: '先问需求再照顾',
        },
        {
          id: 'quiet-stall',
          label: '“找个安静摊子。”你把热茶摆在她手边：“想走随时走。”',
          tone: 'secret',
          reply: '“这句我记下了。”夏娜捧着热茶，热气糊了半张脸，“明天要塞照打。今晚的账，今晚不算。”',
          styleValue: '尊重停留与退出',
        },
      ],
      closing: '打烊铃响前，你们把汤分完了。夏娜没提“下次”，起身时却把伞留在了你那边——雨还没停，她自己走进了雨里，走得比平时慢。',
    },

    conflict: {
      title: '暂停键不是投降',
      location: '下线后 · 空白会议室',
      opening: '下线后的空白会议室只剩一张双人桌。夏娜发现你把临时约会改成了一张排到下个月的安排表，她把表推回来，语气还是平的：“你想要准信，我想喘口气。今晚不谈出个结果，你连暂停都能排成任务。”',
      firstChoices: [
        {
          id: 'pause-the-plan',
          label: '合上安排表：“今晚先停。等你我都能把话说完整，再约时间。”',
          tone: 'calm',
          reply: '夏娜点头，把笔推回你面前：“停可以。但别存进草稿箱就当处理过了——留一个你肯回来谈的日子，写现在。”',
          styleValue: '清楚暂停不消失',
        },
        {
          id: 'name-both-needs',
          label: '“我需要一个准话，你需要多少空间？各说一条底线。”',
          tone: 'bold',
          reply: '“行。”她抬眼，“我的底线先说：空间不是能砍价的数字。你说你的，我不保证当场答应——你也别拿不答应当拒绝。”',
          styleValue: '坦白需求不施压',
        },
      ],
      middle: '两张纸推到桌子中间：一张写“别消失”，一张写“别逼近”。夏娜把它们并排压住，指尖在“别逼近”那张上停了两秒——你猜那句话是她写给自己的。“第二件事。写下来，还是各自出去十分钟再回来？”',
      secondChoices: [
        {
          id: 'write-boundary-note',
          label: '写下：“我会想确认，但不连发追问。你要暂停，说个大概的回来时间。”',
          tone: 'calm',
          reply: '夏娜逐字看完，提笔补了一行：“‘大概’不是打包票，这条留着。”她把纸折成两半，“我做不到的时候也会说。不拿强硬包装失控——这句是抄你的，别得意。”',
          styleValue: '把边界写成约定',
        },
        {
          id: 'leave-and-return',
          label: '起身：“我先出去十分钟。还谈不下去就改天，不拿沉默当答案。”',
          tone: 'bold',
          reply: '“去吧。”夏娜没有留你，只把你那杯茶往桌里挪了挪，免得凉透，“今晚没结论就没结论。总比在气头上签字强。”',
          styleValue: '用距离保护对话',
        },
      ],
      closing: '十分钟后你回来，会议室的灯关了一半，她还坐在原位，两张纸压在杯子底下。见你进门，她只说了一句：“茶还温。坐下，从哪张开始？”',
    },

    reconciliation: {
      title: '把错处留在两个人之间',
      location: '幻想夜市 · 打烊后的河边',
      opening: '河边摊灯一盏盏灭下去。夏娜把那张纸带来了，没拿它当成绩单：“我道歉。上次你追问，我全当噪音挡回去——你为靠近我，花了猜的力气。这句我练了一路，就说到这里。”',
      firstChoices: [
        {
          id: 'own-the-cost',
          label: '“我也有份。你说暂停，我还追着要结论。你讲完，我再讲我的。”',
          tone: 'warm',
          reply: '夏娜没说“没事”。她盯着河面看了一会：“这样道歉才算数。”顿了顿又道，“你不当场要确认了，我也不能再把冷处理叫克制。扯平——这次是真的扯平。”',
          styleValue: '先承认代价再靠近',
        },
        {
          id: 'name-the-fears',
          label: '“先别互相原谅。各说一件下次最怕的事。”',
          tone: 'calm',
          reply: '“可以。”她把纸翻过来，“你先。”听你说完被晾着的滋味，她才慢慢开口：“我怕有一天，职责把我吃得只剩职责，你敲门，我应的是公事。”河灯漂过去一盏，她没再往下说。',
          styleValue: '允许两边同时受伤',
        },
      ],
      middle: '纸上的两条约定被水汽浸得发软。夏娜把笔横在两人中间：“定一条做得到的。暂停时给个回来的时间，还是吵起来先问一句‘要人陪还是要空间’？”',
      secondChoices: [
        {
          id: 'set-return-window',
          label: '“暂停时给个大概的回来时间。做不到就发一句话。”',
          tone: 'calm',
          reply: '夏娜写下时间范围，字迹比平时潦草：“我失约，你拿这条来拍我。你着急，也可以提前重谈。”她把笔一收，“都不用装没事，装得都不像。”',
          styleValue: '约定回访不催答案',
        },
        {
          id: 'ask-before-help',
          label: '“先问要陪还是要空间，听到答案照做。”',
          tone: 'warm',
          reply: '“这能让我少自以为是。”夏娜收起纸，忽然伸手把你肩上的一片落叶弹掉，“我还是会选错。你可以纠正我——纠正不算翻脸。”',
          styleValue: '先问再给出照顾',
        },
      ],
      closing: '河灯漂过最后一段黑水。夏娜把两条约定折好塞进口袋，站起来活动肩膀：“走吧。再坐下去，明天出勤表要难看了。”她走出两步，回头看你还没动，就停下来等——这次没催。',
    },
  },

  qifu: {
    secondDate: {
      title: '不置顶的同行',
      location: '幻想夜市 · 无公告茶亭',
      opening: '祈福在茶亭门口站着，手机屏幕亮着，输入框里的行程通知删了又写。见你来了，她按灭屏幕，像是没收作案工具：“今天没有流程。我练了一路怎么不把自己变成导游——你先告诉我，第一站你想去哪？”',
      firstChoices: [
        {
          id: 'ask-first',
          label: '“你问我之前，自己先选一个。不用完美路线。”',
          tone: 'warm',
          reply: '祈福愣了一下，松开一直攥着的管理员徽章：“……茶亭。我想坐那。”她说完自己先笑了，“原来‘我想’两个字，比公告难发。”',
          styleValue: '先问再共同决定',
        },
        {
          id: 'split-route',
          label: '把地图折成两半：“一人选一段。走累了就说。”',
          tone: 'secret',
          reply: '“像一条没置顶的规定。”祈福把半张地图收进袖子，“你留一半决定权，我留一半喊停的权利。”她走出两步又回头，“这半张我选错了也不许笑。”',
          styleValue: '共享决定也保留退路',
        },
      ],
      middle: '茶亭的铃铛被风吹响。祈福把两杯茶推近，手机扣在桌上，群消息一条条弹，她一条都没看——手指在桌沿敲着，明显在忍。“下一段，”她问，声音放得很轻，“我陪你安静坐着，还是各走一盏灯再汇合？”',
      secondChoices: [
        {
          id: 'sit-without-notice',
          label: '“坐一会。你陪着就行。”',
          tone: 'warm',
          reply: '祈福把刚摸到的手机又推远了半寸：“好。”沉默了半盏茶的功夫，她忽然说，“原来不用给沉默写说明，它是自己满的。”',
          styleValue: '安静陪伴不替人发言',
        },
        {
          id: 'walk-and-rejoin',
          label: '“各走一盏灯再汇合。回来时可以改主意。”',
          tone: 'calm',
          reply: '“这要冒错过彼此的险。”祈福把路线分成两段，在你的半张上画了个小小的灯笼当记号，“但汇合如果不是命令……”她顿了顿，“那我走慢一点，给你追上来的机会。”',
          styleValue: '给彼此空间再相逢',
        },
      ],
      closing: '茶亭打烊，祈福摸出纸笔，习惯性地要写今日小结，写了两个字又划掉，改成一把歪歪扭扭的小伞。她把纸折起来塞给你：“不登记了。这张归你保管，丢了不补。”',
    },

    conflict: {
      title: '权限之外的争执',
      location: '下线后 · 关灯的公告栏',
      opening: '下线后的公告栏一片空白。祈福站在栏前，手里还捏着一枚没按上去的图钉：“我想替你把路铺平，你觉得那是被接管。”她转过身，图钉在指间转了一圈，“我们争的不是谁更体贴——是谁有权决定靠近的方式。这句话我写不出来，只能当面说。”',
      firstChoices: [
        {
          id: 'name-consent',
          label: '“先问，别直接替我决定。我答得慢，不等于你可以接手。”',
          tone: 'calm',
          reply: '祈福把图钉收回掌心，握了一下才开口：“听见了。那我也说一句——被关在门外，我会不安。你的边界，不能要求我没有感觉。”她抬起眼，“这句不是谈判筹码，是实情。”',
          styleValue: '先问许可再靠近',
        },
        {
          id: 'state-care-limit',
          label: '“我知道你想照顾我，但这个安排我不接受。”',
          tone: 'bold',
          reply: '“拒绝安排，不等于拒绝我。”祈福复述了一遍，像在核对措辞，“我会尊重暂停。”她把徽章摘下来放在栏架上，“但我的失落不会装没发生过。它今晚住我这，不搬去你那。”',
          styleValue: '拒绝安排不否定感情',
        },
      ],
      middle: '公告栏还是空的。祈福拿出两枚图钉，一蓝一红，排在栏架上：“一枚是‘先征得同意’，一枚是‘先说我能给什么’。争执靠重复道歉结束不了——你来定，先钉哪枚？”',
      secondChoices: [
        {
          id: 'pin-consent-first',
          label: '把蓝钉按上去：“任何照顾先问可不可以。我说不，你可以难过，但不能拿难过说服我。”',
          tone: 'calm',
          reply: '祈福盯着那枚蓝钉看了很久：“难过我留着，借它改你的答案——不行。”她伸手把钉子按实，“代价是，我以后也不能再说‘为你好’。这四个字，退役。”',
          styleValue: '把同意放在照顾之前',
        },
        {
          id: 'set-pause-channel',
          label: '把红钉按在旁边：“先停十五分钟，只发一句‘我还在，等下谈’。”',
          tone: 'warm',
          reply: '“十五分钟不是万能钥匙。”祈福点头，拿出随身的小本子记下，“它让我们喘气，也意味着问题今晚不会自己消失。”她撕下那页递给你，“两个人都得回来。这张你拿着，防我超时。”',
          styleValue: '暂停有时限也可重议',
        },
      ],
      closing: '公告栏最后只留了两枚图钉，一条通知都没生成。祈福把管理员徽章别回去，别歪了也没管：“走吧。今晚唯一想发出去的公告，栏上贴不下。”',
    },

    reconciliation: {
      title: '把挽留写成私信',
      location: '幻想夜市 · 鸟居后的雨廊',
      opening: '雨廊尽头挂着一排祈福写了没发的私信。她当着你的面把最新那封撕了：“我来道歉，不是来申请原谅。上次我用最熟练的权限替你做了决定——你没了选择，我也没得到一句真话。”',
      firstChoices: [
        {
          id: 'accept-no-announcement',
          label: '“道歉我收下了。但我们的事，先不官宣。”',
          tone: 'calm',
          reply: '祈福把碎纸收进掌心，收得很慢，像在收一份没人签收的公文：“你不马上恢复信任，这份不安我受着。”她抬眼，“我不再替你推进。这是我该付的，不记账。”',
          styleValue: '承认损失再谈修复',
        },
        {
          id: 'write-next-step',
          label: '“各写一条下次能做到的做法。”',
          tone: 'warm',
          reply: '“好。”祈福没去摸公告章，从袖子里取出两支笔，一支先递给你，“修复也要双方同意，不是我道了歉就自动生效。”她在自己那页顶上写了三个字又遮住，“你不许偷看。”',
          styleValue: '让修复也需要同意',
        },
      ],
      middle: '两张纸摊开：一张写“先问”，一张写“说完会回来”。祈福看着它们：“规定只能减少伤害，保证不了不失望。”雨滴从廊檐串成线，“下一件事——约一次复盘，还是先约好谁都能叫停？”',
      secondChoices: [
        {
          id: 'schedule-review',
          label: '“一周后复盘一次：哪些做到了，哪些还难受。”',
          tone: 'calm',
          reply: '祈福在页脚写下“只谈事实和感受，不评优劣”：“你还不满意的部分，我听着。”她停笔，“约定也能改。不把旧话供起来——供起来的话都不新鲜了。”',
          styleValue: '定期复盘但不考核彼此',
        },
        {
          id: 'keep-stop-word',
          label: '“先约一个叫停词。说出口就停，不追问原因。”',
          tone: 'secret',
          reply: '“可以。但叫停之后的空白，我会不安。”祈福把这句也写了进去，字迹很工整，“不安我自己处理，不拿它催你提前回来。”她把笔帽扣上，“这是承诺，不是流程。”',
          styleValue: '用叫停保护重新靠近',
        },
      ],
      closing: '雨停前，没发出去的私信只剩一封。祈福把它从廊上取下来递给你，信封上一个字都没写：“以后我用自己的名字留你。”她撑开伞走进雨里，伞面倾向你这边。',
    },
  },

  chenyi: {
    secondDate: {
      title: '十分钟以前的晚风',
      location: '幻想夜市 · 延迟信箱外的风廊',
      opening: '辰逸把手机押给摊主保管，押金十块。走回来不到十步，他回头看了两次：“第二次约会不靠已读。”他把手插进兜里，像在按住什么，“说吧，今晚怎么走？我先声明，我不擅长慢。”',
      firstChoices: [
        {
          id: 'walk-and-leave-space',
          label: '“先陪我走一圈。想说就说，今晚不用把沉默填满。”',
          tone: 'warm',
          reply: '辰逸走得前快后慢，第三次折返等你的时候终于忍不住了：“你不说话的时候，我脑子里的草稿能写到明年。”他踢开一颗石子，“但难是我的事。你走你的。”',
          styleValue: '陪伴留白不急着确认',
        },
        {
          id: 'separate-ten-minutes',
          label: '“各走十分钟再碰头。不想继续就直接说。”',
          tone: 'calm',
          reply: '“行。”他当场设了倒计时，屏幕冲你亮了一下，“我会回来。”走出去三步又回头补充，“回来不是你必须继续的凭证。听得见‘结束’……也算照顾，这词我刚学的。”',
          styleValue: '给空间也说清回返',
        },
      ],
      middle: '风廊把每句话都拖慢半拍。辰逸第无数次把手从空气里的发送键上挪开：“我想知道你在想什么。但‘想知道’不等于‘有资格要’——这句也是我背下来的。”他抓了抓头发，“下一步，写张短笺各说需求，还是当面只说一句话？”',
      secondChoices: [
        {
          id: 'write-needs',
          label: '递短笺：“我需要你少猜，也请你先问‘能不能谈’。”',
          tone: 'warm',
          reply: '辰逸读完笑出了声：“总算有条规矩不把侦查权发给我。”他提笔补了一行递回来：“你的‘及时’不是‘立刻’。我的心安，不该靠你加班。”字丑，但一笔一划。',
          styleValue: '说清需求不让对方加班',
        },
        {
          id: 'one-sentence-checkin',
          label: '“只说一句：要陪、要空间，或者不确定。说完就停。”',
          tone: 'calm',
          reply: '“三个选项装不下人生。”辰逸收了玩笑，靠在廊柱上，“但至少我不用把沉默翻译成命令了。”他看着风廊尽头，“你选‘不确定’，我也在原地。这个我做得到。”',
          styleValue: '简短报备不追问到底',
        },
      ],
      closing: '信箱那边又亮了一次送达提示。辰逸没去看，摊主喊他取手机，他摆摆手说再押一小时。晚风穿过廊子，他忽然开口：“原来不盯着手机，十分钟也挺长的。”顿了顿，“……长是长，不难受。”',
    },

    conflict: {
      title: '没有回应也不是失职',
      location: '下线后 · 失效的已读大厅',
      opening: '失效的已读大厅里，每条消息都是灰的。辰逸站在你那张没回的短笺前面，手攥着又松开：“我懂这不是命令。可你没回，我这里——”他捶了下胸口，“还是觉得被否定了。你想停，我想追到结论。我知道这已经在伤你了，所以我先来的。”',
      firstChoices: [
        {
          id: 'pause-before-explaining',
          label: '“我现在不解释了。你可以失望，但不能连发追问。”',
          tone: 'calm',
          reply: '辰逸把手放下，退了一步，又退了一步：“我停。但情绪不会立刻归零，这个我不骗你。”他指着地上的灰消息，“这些要是再多一条，你就当我犯病了，把这条规矩拍我脸上。”',
          styleValue: '先止损再约定谈话',
        },
        {
          id: 'explain-once',
          label: '“没回的原因我可以说，但只说一次。说完你还是不安，就先停。”',
          tone: 'bold',
          reply: '“一次说明治不好我，这个我认。”辰逸点开草稿箱，里面躺着十七条没发的追问，他当着你面一条条删，“你的条件我听见。我可能还是会想追问——先跟你报备这一点，省得你说我违约。”',
          styleValue: '有限说明不换取服从',
        },
      ],
      middle: '大厅里所有灰色提示同时闪起来，像一群没耐心的眼睛。辰逸抬手把它们全部静音，动作一气呵成，显然练过：“问题不是一句解释够不够，是剩下的不安谁来扛。你选——写个停止追问的暗号，还是各自离场，等情绪落地？”',
      secondChoices: [
        {
          id: 'use-stop-signal',
          label: '“我发‘暂停’，你就停。没给回谈时间的话，你隔天只问一次。”',
          tone: 'calm',
          reply: '辰逸把“隔天一次”圈起来，嘴里嘀咕：“一天一次，配额制……”他抬头，“你可能还是觉得被催。但它也不要求我无限等。”他伸出拳头跟你碰了一下，“这条，签。”',
          styleValue: '用信号停止连续追问',
        },
        {
          id: 'leave-and-set-date',
          label: '“先离场。明晚约二十分钟，期间不靠想象补剧情。”',
          tone: 'secret',
          reply: '“明晚二十分钟。”他记下，设了两个闹钟，“代价是今晚没结论。”走到大厅门口，他停下，“不在最刺耳的时候给关系判刑——这话谁说的？算了，反正同意。”',
          styleValue: '延后处理不靠沉默惩罚',
        },
      ],
      closing: '大厅恢复空白。辰逸把手机扣在桌上，扣得很用力，像在封印什么：“我把焦虑变成追问，这个我道歉。”他盯着自己的手背看了两秒，“……说完了。没打草稿，就这水平。”',
    },

    reconciliation: {
      title: '把已读还给自己',
      location: '幻想夜市 · 无已读小径尽头',
      opening: '无已读小径尽头，辰逸带来一张揉得发皱的时间表，边角还有被撕过又粘回去的痕迹：“我来道歉。上次我把你的沉默当成待办，逼你又解释又安抚。”他把纸摊开，“我这边也付了代价——不肯信你。两笔都认，不许抹零。”',
      firstChoices: [
        {
          id: 'name-both-costs',
          label: '“我也有要道歉的：知道你急，还用沉默让你一个人猜。”',
          tone: 'warm',
          reply: '辰逸没说“那就算了”。他把时间表撕成两半，一半塞给你：“谢谢你不替我免单。”他别过脸，“两边的代价都认，才轮得到谈下一步。拿亲密糊裂缝的事，我们不干。”',
          styleValue: '不急着翻篇承认代价',
        },
        {
          id: 'list-stop-and-try',
          label: '“各说一条以后停做的，再说一条愿意试着做的。”',
          tone: 'calm',
          reply: '“停追问，停冷处理。”辰逸分两栏写下，笔在第二栏停了很久，“看着对称，做起来不一样难。”他把笔一搁，“难的那半也得写出来。不然这表就是糊弄。”',
          styleValue: '同时停止伤害动作',
        },
      ],
      middle: '他把纸分成“停做”和“试做”两栏：“我可以不把‘没回’当否定，但还是会担心。你可以说要空间，但会觉得麻烦。”风从巷子口灌进来，他用手压住纸，“下一轮——先定回谈时间，还是先定一句低压力的报平安？”',
      secondChoices: [
        {
          id: 'set-return-time',
          label: '“先定回谈时间，哪怕只说‘周末谈’。改期可以，但要主动说。”',
          tone: 'calm',
          reply: '辰逸写下改期规则，嘴里念：“延期我受着，不把延期当拒绝……”他抬眼，“你也得负担‘说一声’的麻烦。等待不能只让一个人管——这句是重点，我加星号了。”',
          styleValue: '约定回谈也允许改期',
        },
        {
          id: 'send-low-pressure',
          label: '“先发一句低压力的：‘我还在，今天不谈’。你收到不追问。”',
          tone: 'warm',
          reply: '“这句不能变成打卡。”他把“不追问”三个字加粗，加粗到纸背都透出来，“要是连续很多天都这样，我们就重谈。”他顿了顿，“暂停不无限续期，这是保护我们俩，不是催你。”',
          styleValue: '报平安但不制造打卡',
        },
      ],
      closing: '辰逸把粘回去的时间表又撕了一次，这次撕得很碎，扬进了巷口的垃圾桶：“修复不是让我从此不怕。”他拍拍手上的纸屑，“是我怕的时候，不再把你当止痛药。”他往外走，“走了。再站下去我又想问你在想什么了。”',
    },
  },

  swordheart: {
    secondDate: {
      title: '休息也要本人签字',
      location: '幻想夜市 · 打烊后的游戏厅',
      opening: '打烊后的游戏厅只剩投币灯。剑斩凡人心带来两张票，站得笔直，像来交接岗：“第二次约会不安排挑战。”她把票递过来，动作标准得像递文件，“挑个最轻松的，还是今天的照顾归你指挥？两个选项我都服从。”',
      firstChoices: [
        {
          id: 'finish-rest',
          label: '“先坐下吃点东西。今天不用证明谁更能撑。”',
          tone: 'warm',
          reply: '她看了看空靶场，又看了看座位，坐下前把椅背调了三次：“把休息当任务执行，听着怪。”她捧着热饮，肩膀一点点塌下来，“……但至少不是我一个人值班。”',
          styleValue: '陪着彼此慢下来',
        },
        {
          id: 'set-stop-rule',
          label: '把票递回一张：“各选一个项目。任何一方喊停就停。”',
          tone: 'bold',
          reply: '“规则对称，执行未必轻松。”她收下那张票，抚平边角，“我可能先喊停，也可能硬撑过头。”她抬眼，“你可以提醒。但不能替我宣布——本人签字才算数。”',
          styleValue: '共同玩也共同喊停',
        },
      ],
      middle: '她终于坐定，还是先确认了出口位置和最晚末班时间，然后才肯把目光收回来：“我管安全，可能少一点随性；你顾节奏，可能少一点惊喜。”投币灯闪了一下，“下一步——并肩打一局，还是各挑一个再交换？”',
      secondChoices: [
        {
          id: 'play-one-round',
          label: '“并肩打一局。不记分。”',
          tone: 'warm',
          reply: '她把计分牌翻到背面，动作干脆：“可以。”一局下来她失误了三次，每次都没皱眉，反而在第三次时笑了一下：“你说累，我不拿‘再来一局’试你。公平起见，我说累，你也别当退缩。”',
          styleValue: '并肩体验不拿输赢衡量',
        },
        {
          id: 'exchange-games',
          label: '“各挑一个再交换。你带我玩不熟的，我标出哪些不能逞强。”',
          tone: 'bold',
          reply: '剑斩凡人心露出一点笑：“你给我新鲜，我给你安全线。”她在跳舞机前站定，姿势仍然标准得可笑，“两边都可能不满意——但不许拿‘负责’当管制。现在开始，你听我口令。”',
          styleValue: '交换新鲜也尊重安全线',
        },
      ],
      closing: '最后一台机器熄屏。她把没用掉的那张票对折，塞进你口袋：“留着。下次用。”走到门口，她回身敬了个不伦不类的礼，“今天没有战果——报告完毕。”她嘴角弯了一下，“但我出勤了。”',
    },

    conflict: {
      title: '出勤表上的空白',
      location: '下线后 · 训练场外的休息室',
      opening: '休息室墙上还挂着出勤表。剑斩凡人心把你临时取消的那格看了两遍，才转身：“你需要随时能改，我需要提前知道。”她的声音不高，但每个字都站得很稳，“你觉得我把约会排成了任务。我觉得，你把我的时间当成了随取随用。”',
      firstChoices: [
        {
          id: 'name-the-impact',
          label: '“临时改动确实让你受损，这个我认。但我不接受你用失望把我押回原计划。”',
          tone: 'calm',
          reply: '“不好听，但是实话。”她把表格放平，指尖在那格空白上停了一下，“我要可预期，不等于我拥有你的时间。你要自由——”她抬起眼，“也不等于我无条件待命。这句说完，我们扯平。”',
          styleValue: '承认影响也保留自由',
        },
        {
          id: 'pause-and-list',
          label: '“先停。各自写下最低需要和不能接受的。”',
          tone: 'bold',
          reply: '剑斩凡人心点头，从墙上取下两张便签，一张拍在你面前：“暂停会让我们错过今晚。”她已经写了起来，字迹工整，“但继续争，约会就成了考核。损失我认——装没事，不行。”',
          styleValue: '暂停争执避免耐心竞赛',
        },
      ],
      middle: '她撕下旧出勤表，底下露出一张空白的：“分歧不是靠缺勤能解决的。”她把笔搁在两人中间，“下一件——立一条可撤销的预约规矩，还是保留弹性、但改期必须通知加补救？”',
      secondChoices: [
        {
          id: 'flexible-reservation',
          label: '“预约都写成暂定，谁都能改，但尽早说。改的人负责重约。”',
          tone: 'calm',
          reply: '“暂定保住自由，主动重约加重责任。”她把这句抄上新表，抄完在末尾添了一行小字，“换我临时有事，让你落空的账，也记我头上。这张表不偏心。”',
          styleValue: '保留弹性主动重约',
        },
        {
          id: 'fixed-rest-window',
          label: '“每周锁一段不许挪的时间。其余各自由。”',
          tone: 'warm',
          reply: '她掂量了一会，在新表上画出一个方框，涂实：“锁一段，少一点随性，但我不用反复等通知。”她把笔帽扣上，“你也让出一部分临时自由——这笔账，不能只算我的。”',
          styleValue: '固定一段其余各自自由',
        },
      ],
      closing: '空白表上没人签全勤。剑斩凡人心把它贴回墙上，贴得端端正正，又伸手挪歪了一度，端详片刻，满意了：“就这样。太整齐的表，看着像没人用过。”',
    },

    reconciliation: {
      title: '迟到的休息报告',
      location: '幻想夜市 · 无人靶场看台',
      opening: '无人靶场的看台只亮一盏灯。剑斩凡人心把一张纸放在两人中间，开头写着“情况说明”，写到一半又划掉，改成“道歉”：“我把守时当认真，把你的临时改动当轻视，让你一直像在接受审判。”她立正了半秒，又刻意放松下来，“这部分我道歉。不要求你立刻恢复原计划。”',
      firstChoices: [
        {
          id: 'own-both-hurts',
          label: '“我也道歉：改了没及时说，让你空等。”',
          tone: 'warm',
          reply: '她点头，把你的话记在纸背面：“这不是保证永不迟到，是承认迟到会伤人。”她想了想，又补一行，“我的道歉也加一条：失望要说出来，不用冷脸替规矩执法。冷脸不算执法装备。”',
          styleValue: '道歉包含影响与责任',
        },
        {
          id: 'listen-before-reply',
          label: '“你说哪一步受的伤，我听完，再讲我当时的难处。”',
          tone: 'calm',
          reply: '“听完不等于同意。”她把纸折成两栏，笔帽咬在嘴里含混地说，“但至少不抢着举证。”说完把笔放正，恢复了平日的语速，“你为改动负责，我为审判式的回法负责。开始吧，你先说。”',
          styleValue: '先听完整再交换困难',
        },
      ],
      middle: '她在看台水泥台上用粉笔画了三格：提前说明、临时改变、事后回看。“规矩不是用来判谁更认真的。”粉笔灰沾了她一手，她没拍，“下一件——固定一种重约方式，还是设一个谁都能喊的休息口令？”',
      secondChoices: [
        {
          id: 'reschedule-directly',
          label: '“改期时直接给两个新时间，对方自由选。”',
          tone: 'calm',
          reply: '她在格子里写下两列时间：“给选项，你多花准备工夫，我少靠猜。”粉笔头断了，她把断茬捏在手里，“两个都不行，也允许说不。修复不是新义务——这句请你也记住。”',
          styleValue: '重约给选项不换取答应',
        },
        {
          id: 'use-rest-word',
          label: '“设个休息口令，谁说了就停。当天只确认安全。”',
          tone: 'secret',
          reply: '“接受。但喊停的人，可能失去当晚解释的机会。”她把这条也标出来，粉笔在“解释”上顿了一下，“这不是罚，是保护。”她拍拍手上的灰，“事后，还是要回来处理。逃岗不算休息。”',
          styleValue: '叫停保护关系再回来',
        },
      ],
      closing: '灯灭前，她把那张纸塞进出勤表最后一页，没盖章，只压平。走出靶场时她说：“这次修复不算完成任务。”夜风吹散她手上的粉笔灰，“所以下次见不见——仍由两个人决定。我等你通知。”',
    },
  },

heartbeat: {
    secondDate: {
      title: '不做A/B测试的夜游',
      location: '幻想夜市 · 无指标糖摊',
      opening: '心跳成瘾把两张路线图钉在摊上：一条人多，一条灯好看。钉完又在旁边写了个“禁”字贴在A/B测试四个字上，一抬头撞上你的目光：“看什么，我在戒。”她把统计笔揣回兜里，“今晚你带路。我保证不优化你。”',
      firstChoices: [
        {
          id: 'ask-before-walking',
          label: '“先别选路线。你今晚想被怎么照顾？”',
          tone: 'warm',
          reply: '心跳成瘾愣住，手指在兜里转了三圈那支笔：“这问题……没有转化率。”她难得卡壳，“想慢一点。别把我当项目跑——就这个。答完了，这题超纲。”',
          styleValue: '先问感受再谈扩张',
        },
        {
          id: 'take-the-small-lane',
          label: '“走人少那条。迷路和找路都算约会时长。”',
          tone: 'bold',
          reply: '“低流量路线，正式开张。”她收起路线图，真的一张都没留，“就算绕远，我也不许自己登记成失败。”走出十米她小声补了句，“……其实我刚才心算了两条路的用时。戒断反应，别理我。”',
          styleValue: '一起试错不急归因',
        },
      ],
      middle: '灯巷尽头只有一张空桌，摊主递来两杯不催单的茶。心跳成瘾坐下，习惯性扫了一圈四周，目光在“本摊翻台率”的小牌子上停了半秒，硬生生挪开：“在这儿久坐，还是边走边把各自的节奏说清楚？先声明，我没有问卷，我只有……好吧我有一个小本子。”',
      secondChoices: [
        {
          id: 'stay-at-empty-stall',
          label: '“坐下，不赶下一摊。你想说的时候，我在听。”',
          tone: 'warm',
          reply: '她把小本子摊开，又合上，最后撕下一页折成纸船，放进桌上的茶渍里：“今晚留存率停盘。”纸船湿了一角，她没去救，“被听见不是任务。你也不用拿安静证明自己还在场——这句是抄来的，出处保密。”',
          styleValue: '给亲密留出慢速空档',
        },
        {
          id: 'set-a-check-in',
          label: '“继续走。每过一盏灯，互相问一次累不累。”',
          tone: 'calm',
          reply: '心跳成瘾点头，把统计笔留在桌上，折了根普通木签拿在手里：“双向回访，样本量二。”她晃了晃木签，“回答可以是‘停下’，也可以是‘继续’。没有错误答案——这功能我现加的。”',
          styleValue: '边走边校准彼此节奏',
        },
      ],
      closing: '河边的灯把影子拉得很长。回程路上她掏出小本子，你瞥见最新一页只画了一条歪歪扭扭的曲线，既没有坐标也没有刻度。她发现你在看，把本子一合：“看不懂就对了。这条曲线叫‘今晚’，没有指标。”',
    },

    conflict: {
      title: '增长表之外的争执',
      location: '幻想夜市 · 回访茶摊',
      opening: '心跳成瘾摊开一张表，表头写着“关系活跃度”：见面次数、回复速度、临时改期。她手指按在纸上，没像往常那样转笔：“高频让我安心。你上次说，这会把‘想见’变成考核。”她抬眼，“我今天不带结论来。你先说，我忍住不记。”',
      firstChoices: [
        {
          id: 'reject-metric-intimacy',
          label: '“频率可以谈。把在乎换算成达标率，不行。”',
          tone: 'bold',
          reply: '她的笑停了一秒，指尖在“达标”两个字上按出褶子：“你不是数据，这我懂。”她把表折了一道，没撕，“可我确实一直拿数字挡害怕。这话我听了不舒服——但不能装没听见。装听不见才是真的不及格。”',
          styleValue: '明确反对把亲密量化',
        },
        {
          id: 'pause-with-return-time',
          label: '“今晚先停，等都能说清楚再续。暂停不算流失。”',
          tone: 'calm',
          reply: '她按住想收表的手，按住，又松开：“停不是退订。”她低声重复了一遍这个词，像在默念咒语，“但我会失去‘立刻确认’的安全感。”她抬眼，“这份不安，也不该你加班来补。今晚我自己带回家。”',
          styleValue: '用清晰暂停守住边界',
        },
      ],
      middle: '她没撕表，也没逼你当场接受。茶摊的灯一盏盏熄下去，表上的字迹越来越模糊：“我还是想知道什么时候有回应。你还是不肯承诺固定频率。”她把笔帽按上，发出很轻的一声咔哒，“现在要定的是——删掉考核列，还是约一次有终点的暂停？”',
      secondChoices: [
        {
          id: 'delete-score-columns',
          label: '“见面计划保留。活跃度、流失、完成率这三列，删。”',
          tone: 'bold',
          reply: '她拧开墨水笔，把三列涂黑，涂得很慢，一列一列来：“计划还会提醒我‘有期待’。”她吹了吹未干的墨迹，“涂黑它们，是提醒我不能拿期待收费。”第三列涂完，她长出一口气，“手有点抖。不是因为心疼表。”',
          styleValue: '保留计划删除考核',
        },
        {
          id: 'schedule-boundary-talk',
          label: '“今晚到此为止，明晚八点再谈。期间谁都不用证明在乎。”',
          tone: 'calm',
          reply: '心跳成瘾把回访表扣下，扣得端端正正：“我会想提前发消息。”她把手机翻过去，“忍住不发。明晚要是还谈，从需求开始，不从数落开始。”她站起身，“八点。我提前两分钟到——这个改不掉，别劝。”',
          styleValue: '用有终点暂停谈分歧',
        },
      ],
      closing: '茶彻底冷了，问题还在桌上。她收拾东西时把那张表折成了原来的一半大，又一半，最后塞进口袋：“带回去当反面教材。”走到巷口她停下，“备注一句：今天没吵完，不算失败案例。算……进行中。”',
    },

    reconciliation: {
      title: '把问卷改成两个人的约定',
      location: '幻想夜市 · 空白招募板',
      opening: '心跳成瘾把那张旧表正面朝下扣在招募板上，先开口，语速比平时快：“我把‘怕失去你’翻译成了‘要求频率’，让你一直替我证明。对不起。”她说完闭了闭眼，“没索要原谅。我就是想问问，修复从哪一步开始——这次你定流程。”',
      firstChoices: [
        {
          id: 'destroy-old-form',
          label: '“先把表销毁。再各自说清，那段时间到底付出了什么。”',
          tone: 'bold',
          reply: '她拿起表，撕第一下没撕开，第二下用了力：“销毁让我失去熟悉的掌控感。”纸片落在板上，她盯着看了一会，“但至少，你不用再进漏斗。”她抬眼，“你暂停时一个人扛的那些，现在说。我忍住不记笔记。”',
          styleValue: '先拆旧表再谈代价',
        },
        {
          id: 'keep-voluntary-reminder',
          label: '“表留着，一起改成自愿提醒，评分全删。”',
          tone: 'calm',
          reply: '心跳点头，把表翻回来，盯着看了很久：“留着它，会提醒我旧习惯，也可能让你重新警惕。”她提笔在表头上写“自愿”两个字，“不装风险不存在。改一列，停下来检查一次——这条写进去，不许跳版本。”',
          styleValue: '保留提醒拒绝评分',
        },
      ],
      middle: '招募板上只剩三行字：“想见”“需要空间”“何时再谈”。心跳成瘾退后一步端详：“销毁能轻松点，但少一条旧路；保留方便，却要反复辨认旧习惯。”她把笔递给你，“下一步，你写。我手抖，写的字难看。”',
      secondChoices: [
        {
          id: 'pause-with-next-day-check',
          label: '“谁想暂停就直说。第二天只确认一件事：还谈不谈。”',
          tone: 'calm',
          reply: '她看着你把这行字写完，轻声念了一遍：“确认不是追讨理由。”她点头，“你暂时不谈，等待我扛。我想谈，你也可以说还没准备好。”她顿了顿，“‘还没’这个词好，比‘不’善良。”',
          styleValue: '暂停明确不追问理由',
        },
        {
          id: 'schedule-time-not-speed',
          label: '“每次见面只约时间，不约回复速度。改期尽早说。”',
          tone: 'warm',
          reply: '心跳成瘾看着那行字，补了个小小的“✓”：“我少一份即时确认，你多一次说明的麻烦。”她把笔帽扣上，“但这比拿沉默做统计诚实。”她忽然笑了，“数据不说谎——可沉默根本不是数据，我以前归类错了。”',
          styleValue: '约定时间不计回应速度',
        },
      ],
      closing: '散场前，她在招募板最底端添了一行小字：“本约定长期灰度。”你问她什么叫长期灰度，她想了想：“就是……上线着，但允许回滚。”她把粉笔一扔，“人话：过着看。这句你听懂就行。”',
    },
  },

  yanqiu: {
    secondDate: {
      title: '先定一条再留一页',
      location: '幻想夜市 · 双人修订席',
      opening: '砚秋水带来一本没有末页的行程册，翻开，前页密密麻麻，最后一页空白。她把笔搁在两人中间：“亲密需要可预期，也需要变更入口。”她指尖点着那页空白，“今晚先排一段，还是交给现场判断？先说清楚，两种我都演练过，两种我都不放心。”',
      firstChoices: [
        {
          id: 'plan-with-blank-page',
          label: '“先定一段时间，再留一页给临场改动。”',
          tone: 'calm',
          reply: '砚秋水在页脚写下“可改”两个字，写完端详片刻：“有边界，我安心。”她合上册子又打开，把“可改”描粗了一圈，“但边界不能替你感受累。到点不等于必须继续——这句列入正文，不做脚注。”',
          styleValue: '先定边界再留余地',
        },
        {
          id: 'trust-live-care',
          label: '“今晚不写行程。你累了告诉我，我留意，但不替你做决定。”',
          tone: 'warm',
          reply: '她合上行程册，手指在封皮上敲了两下，像在告别：“这要求我相信你会说。”她抬眼，“也要求你相信我——听见了，不追问成审议。”她把册子塞进包里，“裸奔一晚上。摔了算我的。”',
          styleValue: '把照顾交给当下判断',
        },
      ],
      middle: '两盏灯之间摆着个“亲密节奏自助章”的摊子：提前安排、现场观察，分开收费。砚秋水看了半天价目表，难得地没掏出章程比对，只把空白页推过来：“下一件——给疲惫设个暗号，还是设几个不带审问的检查点？先声明，这摊子的定价模型我看不上，但我们今晚不投诉。”',
      secondChoices: [
        {
          id: 'set-rest-signal',
          label: '“给‘累’设个暗号，听到就停。”',
          tone: 'secret',
          reply: '砚秋水提笔写下“灯灭”二字：“暗号省解释，也可能错过细节。”她在旁边添了一行小字，“所以停下之后，必须回来问。”她收笔，“空白不能代替结论。这条我坚持。”',
          styleValue: '用暗号保护疲惫边界',
        },
        {
          id: 'use-checkpoints',
          label: '“每两盏灯问一次要不要继续。回答可以是‘换路’，不用给理由。”',
          tone: 'calm',
          reply: '她把检查点画成小圆圈，间隔均匀，画到第三个时笔停了：“频繁确认会打断情绪。”她把第三个圈改成了一朵歪的云，“但至少允许改道。”她看着那朵云，“我们接受变慢。慢，不记成失败——这句不归类，就是句实话。”',
          styleValue: '定点确认允许随时改道',
        },
      ],
      closing: '夜市收摊，行程册还空着一页。砚秋水在页眉写了四个字“双方可用”，写完发现墨没干，拿纸角小心吸掉：“今晚只确认了一件事。”她把册子收好，“任何节奏，都可以重新谈。”她起身，“收工。这页的归档日期，我留空。”',
    },

    conflict: {
      title: '提前告知的边界',
      location: '幻想夜市 · 旧书占卜摊',
      opening: '砚秋水把一页纸摊在旧书摊的绒布上，标题是“临时变更需提前说明”。她没像往常那样带红笔：“我需要可预期，这不是控制。你说没法永远提前，这也不是失责。”她抬眼，“所以今晚不带修订意见。先把真正的分歧念出来：我把提前告知当照顾，你把不能预知当诚实。念完了，它对吗？”',
      firstChoices: [
        {
          id: 'state-real-limit',
          label: '“我能承诺尽早说，承诺不了永远提前。这条不许写成考核。”',
          tone: 'bold',
          reply: '她没立刻反驳，手指在“考核”两个字上空停了一下：“那等待和落空，归我承担。”她把那页纸折起一角，“但把做不到的保证写进条款，只是另一种不诚实。”她点头，“你这句，成立。我不修订，我接受。”',
          styleValue: '承诺告知不承诺预知',
        },
        {
          id: 'pause-and-list-needs',
          label: '“先暂停这次安排。各自写最低需求，再回来核对。”',
          tone: 'calm',
          reply: '砚秋水收起笔，动作比平时慢：“暂停会推迟结论，也让我今晚拿不到保证。”她把纸对折，“但继续争下去，需求只会被写成判词。”她抬眼，“判词没有执行力。我去写我的三条，你也去。一刻钟，原地见。”',
          styleValue: '暂停争论先写最低需求',
        },
      ],
      middle: '一刻钟后，她把两种代价并排写下：立即谈，关心可能变成催促；暂缓谈，不安要多留一晚。字迹还是一贯的工整，只是行距比平时宽：“条款解决不了分歧。”她把笔放平，“桌上只剩一个问题——先对最低需求，还是先补例外条款？”',
      secondChoices: [
        {
          id: 'compare-minimum-needs',
          label: '“各写三条最低需求。只谈做不做得到，不谈谁有理。”',
          tone: 'calm',
          reply: '砚秋水写下自己的三条，第四条写了又划，最后把“做不到要早说”填进去：“这会暴露我们都不完美。”她端详那四条，没再改，“但至少，道德评判不许混进执行。谁混，谁请奶茶。”',
          styleValue: '先谈最低需求不争输赢',
        },
        {
          id: 'add-unexpected-exception',
          label: '“保留提前告知，加一条例外：不可预见的情况、无需解释的暂停。”',
          tone: 'secret',
          reply: '她提笔，落笔前停了足有十秒：“例外会削弱我的可预期，保住你的喘息。”她写下条款，字迹放得很慢，“用多了，信任会降。”写完，她在这句后面加了个括号，“（所以这条不写进小字。写进正文，加粗。）”',
          styleValue: '给规则留出暂停例外',
        },
      ],
      closing: '收摊的钟声过了三次，那页纸上的字晾干了。砚秋水把它收进册子，夹在没有末页的那一章前面：“争议记录保留。”她拍拍册子，“但约定加一条：不因一次变更给人定性。”她起身离开摊位，“走了。今晚这页，不下结论。”',
    },

    reconciliation: {
      title: '可执行的道歉',
      location: '下线后架空空间 · 没有裁判的档案室',
      opening: '砚秋水把一页新纸放上案头，标题栏里她先写了“道歉”，想了想，在后面加了句“不是修订通知”：“我把你的不确定当成对我的否定，逼你先交保证，才肯听需求。对不起。”她把笔放平，“我也承认，我需要可预期。但这份需要，不能全让你来偿还。今天先听，后写。”',
      firstChoices: [
        {
          id: 'listen-before-drafting',
          label: '“先听我说，这段时间哪里觉得被压迫。听完再决定写不写条款。”',
          tone: 'warm',
          reply: '她合上笔帽，双手叠在桌上，坐直：“开始吧。”听的过程中她的手指动了三次，三次都没碰笔。等你说完，她才开口，声音有点干：“听完没有新条款，只有更难办的理解。”她停了一下，“这段没结论的时间，我愿意先受着。”',
          styleValue: '先听伤口再决定条款',
        },
        {
          id: 'draft-short-agreement',
          label: '“现在就写一份短的，只留两个人都愿意承担的。”',
          tone: 'calm',
          reply: '砚秋水点头，笔尖悬在纸面上方：“短约给方向，也可能让旧习惯借格式还魂。”她写下第一行，停住，在页边添了句注，“每写一行，问一句：这条是谁在承担？”她抬眼，“答不上来的行，当场删。你来监督。”',
          styleValue: '短约共担不借格式控制',
        },
      ],
      middle: '先说伤口，还是先写短约——修复都没有立刻变轻。案头的灯修过，还是忽明忽暗。砚秋水把笔放在两人中间：“前者要耐心，后者要复核。”她看着那支笔，“往后的承诺，要哪一种才执行得下去？这次我不给候选答案，你先出。”',
      secondChoices: [
        {
          id: 'allow-reschedule',
          label: '“把‘可预期’改成‘提前告知加允许改期’。做不到的时候，先说。”',
          tone: 'calm',
          reply: '她提笔圈起“允许改期”，圈了两圈：“我失去按原计划推进的安心，你背上尽早说明的麻烦。”她在旁边画了一架小天平，两端各放了一个点，“好处不许只占一边。”她看着那架天平，“丑是丑，平是平的。”',
          styleValue: '提前说明允许彼此改期',
        },
        {
          id: 'protect-unscheduled-night',
          label: '“每周留一晚，什么都不安排。让关系留一块没有条款的地方。”',
          tone: 'warm',
          reply: '砚秋水慢慢写下这一条，字迹从工整逐渐写松：“空白让我不安。”她写完，把笔搁下，“但它拦得住规则占满所有靠近。”她在句尾画了个小方框，空着没打勾，“那一晚，谁也不许用来补条款。这个框，那一晚也不许勾。”',
          styleValue: '留出空白不让规则占满',
        },
      ],
      closing: '她把道歉和约定放在同一页，从头到尾读了一遍，在页脚盖了章，又拿笔把章框起来，写了四个字“此页不归档”。做完这些，她把册子合上，难得地笑了：“走吧。档案室要熄灯了——这条不是我定的，是灯定的。”',
    },
  },

  huayue: {
    secondDate: {
      title: '休息也要共同决定',
      location: '幻想夜市 · 打烊后休息区',
      opening: '华月乌大王端着两杯饮料走进打烊后的休息区，系统偏在这时弹出“未完成提醒”，红字一闪一闪。她盯着看了三秒，把托盘放下，人挡在你和红字中间：“先说好。先休息，残局等我；先收尾，今晚只剩工作。”她把一杯塞进你手里，“你选。我端着杯子呢，没法反悔。”',
      firstChoices: [
        {
          id: 'close-reminder-first',
          label: '“先关提醒。喝完这杯，再决定要不要收尾。”',
          tone: 'warm',
          reply: '华月按住关机键，按下去的那一下肩膀明显松了：“停下来我会有点慌，实话。”她捧着杯子坐下来，两条腿总算伸直，“但至少今晚知道了——喝水不是偷懒。”她碰了碰你的杯子，“也不是把责任丢给你。干杯，别笑这个词。”',
          styleValue: '先照顾人再处理残局',
        },
        {
          id: 'split-three-tasks',
          label: '“把剩下的事列成三项，十分钟后一起下班。”',
          tone: 'calm',
          reply: '她抽出随身的清单，刷刷划掉一串，只留三行：“切小了我安心。”她把清单折短，塞进你口袋，“但十分钟很可能拖长。”她指着你口袋，“到点你提醒我。不许替我无限加班——这条现在生效。”',
          styleValue: '把责任切小共同承担',
        },
      ],
      middle: '十分钟过去，提醒没再弹，饮料也没喝完。华月把杯子在桌上转了半圈，这回没替你决定：“最后一项，可以带到明天，也可以现在一起做完。”她抬眼，“但先说好，今晚谁承担什么。别又是我默认全收。”',
      secondChoices: [
        {
          id: 'carry-one-task',
          label: '“你负责关灯，我把未完项挪到明天。今晚不带进约会。”',
          tone: 'calm',
          reply: '华月看着那行被挪走的字，手指在桌面上敲了两下：“明天会多一笔压力，你替我留了出口。”她站起身去关灯，关到一半回头，“可我也得认：出口不是自动归你负责的。下次换我给你留。”灯灭了，休息区只剩窗外的灯笼光。',
          styleValue: '分担收尾不吞掉休息',
        },
        {
          id: 'leave-work-for-tomorrow',
          label: '“今天就不收。明天的损失明天一起看。”',
          tone: 'bold',
          reply: '她笑得有点苦：“延期意味着，我明早一睁眼就背着清单。”她把清单揉成一团，又展开压平，“但今晚至少，不是你陪我受罚。”她把纸塞回口袋，一次性把饮料喝完，“两笔账都认。走了，再坐下去我要反悔。”',
          styleValue: '允许延期共同面对后果',
        },
      ],
      closing: '夜市熄灯，华月把提醒设置改成“明日再看”，改完把手机倒扣：“以前我觉得，把残局收完才算对得起今天。”她锁上休息区的门，钥匙在指头上转了一圈，“今天算了。门我锁的，账明天算——这句话也记下来，是我说的。”',
    },

    conflict: {
      title: '不做无期限待命',
      location: '幻想夜市 · 无人值班台',
      opening: '华月乌大王临时把约会换成了收尾，清单摊了一桌，你到场时她头也没抬，先补了句“你别走太远”。说完她自己也停了，笔悬在半空：“……你听见了。我想有人在，却不肯开口求助。”她把笔放下，“你要说你不接受被排进待命栏，我知道。你要说我拿你当免费人力，我也知道。先让我问一句：我不接，这残局谁管？”',
      firstChoices: [
        {
          id: 'state-on-call-boundary',
          label: '“我可以陪你，但不接受不说一声就被排进待命栏。现在谈清楚。”',
          tone: 'bold',
          reply: '华月把笔彻底搁下，人靠进椅背：“谈清楚会耽误收尾，也等于承认我刚才在要求你待命。”她捏了捏眉心，“可不说，就是把我的压力转手给你。”她抬眼，“……‘你别走太远’那句，收回。它不是请求，是派遣。我听出来了。”',
          styleValue: '陪伴可以但拒绝待命',
        },
        {
          id: 'leave-and-reconnect',
          label: '“我先走。等你能说清楚需要我做什么，再联系。这不是罚你。”',
          tone: 'calm',
          reply: '她皱眉，手指在桌沿收紧又放开：“你走，今晚我一个人扛；你留，又没了选择。”她盯着清单看了很久，“这个边界有代价。”她低声说，“我不能把它粉饰成你冷漠。”她抬手挥了一下，像在赶自己不听话的情绪，“走吧。门口那盏灯我给你留着。”',
          styleValue: '离开现场保留联系选择',
        },
      ],
      middle: '清单上的红字还在，华月也没突然学会求助。她把最后一张空白栏推过来：“两种不舒服都在台面上：留下，要限定承担；离开，要暂时失去陪伴。”她按着纸角，“先拆请求，还是明天再谈？选哪个我都不记仇——记了也不算数。”',
      secondChoices: [
        {
          id: 'separate-request-types',
          label: '“把‘需要’拆开：要陪伴、要帮忙、要独处。一次只许选一种。”',
          tone: 'calm',
          reply: '华月写下三个选项，写完在每个后面画了小方框：“选陪伴就不许暗中派活，选独处就不许怪你没留。”她端详那三个框，“清楚是显得生硬。”她把笔一搁，“但至少不偷换。我这人最恨偷换，尤其是自己偷换。”',
          styleValue: '把需要说清拒绝偷换',
        },
        {
          id: 'schedule-next-day-talk',
          label: '“今晚各自收尾。明天固定一段时间，把这次分歧谈完。”',
          tone: 'calm',
          reply: '她看向未完成项，红字还在闪：“明天谈，意味着今晚没人被哄好。”她伸手把屏幕按灭了，“也意味着，不在最累的时候开庭。”她在清单顶上写了明天的时辰，“时间我留出来。这一行，不许被工作插队。”',
          styleValue: '延期谈判不在疲惫时定性',
        },
      ],
      closing: '最后一盏工作灯熄灭，残局没有因此消失。华月锁值班台的时候忽然说：“刚才你选哪个，我都没生气。”钥匙在她手里停了一下，“我气的是，我居然需要你走了才发现自己在干什么。”她把钥匙收好，“记我账上。下次对账，我先认这笔。”',
    },

    reconciliation: {
      title: '不把同行列成劳务',
      location: '幻想夜市 · 无人值班台',
      opening: '华月乌大王把那张清单带来，当着你的面把“同行”一栏从“劳务”里划出来，划得很重，纸都起了毛：“我把依赖伪装成了安排，给你发了无期限待命；你退出之后，我又把失落记成你的不负责。”她把笔拍在桌上，“对不起。今天没拿收尾成果来抵债——成果在抽屉里，跟这事无关。你只说，边界怎么重建。”',
      firstChoices: [
        {
          id: 'delete-on-call-row',
          label: '“先把待命栏删了。再各自说一次，当时到底扛了什么。”',
          tone: 'bold',
          reply: '她拿起笔，那一栏划掉的时候手很稳：“我失去随叫随到的安全垫，你拿回自己的时间。”她抬眼，“公平。”她把纸转过来对着你，“你走时候心里那点愧疚，也得说。今晚不能只让我认错——这不叫计较，叫对账。”',
          styleValue: '先删待命再承认代价',
        },
        {
          id: 'keep-consent-checklist',
          label: '“互助清单保留，但每项写明：是否自愿，到几点结束。”',
          tone: 'calm',
          reply: '华月点头，提笔加了两列，列宽留得很大：“清单保住协作，也会勾起旧的工作口气。”她写完检查了一遍，“所以每次都要复核。”她敲敲纸面，“不许格式替任何人点头。格式没长嘴。”',
          styleValue: '保留互助明确边界期限',
        },
      ],
      middle: '值班台上只剩两列：想要的支持，给得出的支持。华月承认自己删待命少一层安全垫，留清单多一轮复核。她把笔推过来，这次推得很轻：“以后的请求，怎么落地？你定格式，我负责执行——执行不了我会说，不硬扛。”',
      secondChoices: [
        {
          id: 'ask-not-command',
          label: '“需要陪伴就直接请求，并接受对方当下可以拒绝。”',
          tone: 'warm',
          reply: '华月写下“请求不等于指令”，写完自己念了一遍：“被拒我会难受。”她没回避这个词，“但不能拿难受把答复改成义务。”她抬眼，“你也要老实说，扛不扛得住。你硬扛，我比被拒还难受。”',
          styleValue: '请求清楚允许彼此拒绝',
        },
        {
          id: 'separate-date-from-help',
          label: '“每次见面前说清：这是约会还是帮忙。临时改动，重新征得同意。”',
          tone: 'calm',
          reply: '她圈出“重新同意”，圈完在边上画了个小铃铛：“少了随手的便利。”她把纸抚平，“保住的是，约会不是隐形值班。”她忽然想起什么，“上次那次，按新标准，算值班。回头补你一场约会，不补账。”',
          styleValue: '约会帮忙分开重新同意',
        },
      ],
      closing: '清单收进抽屉前，华月在封皮上写了一行字。你没看清，问她，她把抽屉关上了：“写的是‘这张表管事，不管人’。”她锁好抽屉，钥匙揣好，“走了。今晚没有待办，只有待会吃什么的重大问题。”',
    },
  },

  wenxian: {
    secondDate: {
      title: '两盏灯的慢速约会',
      location: '幻想夜市 · 花灯长椅',
      opening: '温陷在花灯长椅上摆了两盏小灯：一盏只能亮十分钟，一盏能提着走。她坐在灯光够不到的半边，见你来了，往旁边挪出一掌宽的位置：“一盏看时间，一盏看路。”她声音很轻，“今晚坐在这儿，还是慢慢走？不急着想，灯还没开始算时间。”',
      firstChoices: [
        {
          id: 'sit-under-short-lamp',
          label: '“先坐这盏灯下。亮多久算多久。”',
          tone: 'warm',
          reply: '温陷伸手护住灯罩，风刚好过来：“时间到了就会暗。”她看着火苗，“这不代表陪伴失败。”她侧过脸对你笑了一下，“谢谢你没有一进门就说‘再坐一会’。那四个字，有时候会压得人不敢走。”',
          styleValue: '让陪伴不被时间追赶',
        },
        {
          id: 'walk-with-mobile-lamp',
          label: '“沿花灯街慢慢走，冷了就回来。”',
          tone: 'calm',
          reply: '她把能移动的那盏提起来，灯光正好照见两个人的鞋尖：“走动会错过一些灯。”她走得很慢，比你想象的还慢，“也能早点发现彼此冷不冷。”一阵风过，她往你这边靠了半步，“比如现在。你那边挡风。”',
          styleValue: '走动中照看彼此温度',
        },
      ],
      middle: '第一盏灯按时熄了，火苗缩下去的时候，温陷替它说了声“辛苦了”。第二盏把影子拖到下一条巷口。她没催你给今晚起名字，只问：“下一次，写一个大概的时间，还是把联系留到想见的时候？”',
      secondChoices: [
        {
          id: 'allow-date-change',
          label: '“写个大概时间，但允许当天改。改期不算缺席。”',
          tone: 'calm',
          reply: '温陷从袖袋里取出一小截粉笔，把时间写在灯座底下，字迹轻得几乎看不见：“有约定，我安心；能改，就不怕失约。”她把粉笔收好，“改的时候说一声就好。不用写检讨——检讨我收过太多，不缺你这份。”',
          styleValue: '约定时间也允许改期',
        },
        {
          id: 'message-when-ready',
          label: '“不写时间。下次想见的时候，各自发一条只给彼此的消息。”',
          tone: 'secret',
          reply: '她看着那盏熄掉的灯，重新点亮了它：“没有日期，会多一些等待。”火光映着她的眼睛，“但那样的消息，是主动靠近，不是被提醒拖回来的。”她把灯递给你，“两种都要勇气。这盏借你壮胆。”',
          styleValue: '主动联系不把等待定罪',
        },
      ],
      closing: '走到河边时，两盏灯一明一暗。温陷把亮着的那盏挂在桥栏上，说留给下一个走夜路的人。回程她一直走在你里侧，快到分别的路口才小声说：“今晚没有起名字。”她摆摆手，“不起名字的晚上，不会被弄丢。”',
    },

    conflict: {
      title: '不替空位担保',
      location: '幻想夜市 · 最后一盏花灯',
      opening: '温陷把一盏空灯摆在两人中间，笔搁在灯座上。她看了很久才开口：“我想在这上面写你的名字。”灯罩里的火苗晃了一下，“写了，我就知道你会回来。你没说话。我也知道你为什么没说话——写了，它就不是灯了，是押条。”',
      firstChoices: [
        {
          id: 'state-limited-return',
          label: '“我能告诉你什么时候来。但名字不写成永远在场的担保。”',
          tone: 'bold',
          reply: '温陷把笔收回去，动作很慢：“我少一份确定。”她把灯转向自己这边，“你不用签一份退不出的承诺。”火苗稳下来之后，她轻声补了句，“想念这件事，我得学着不把它变成索取。这句话我说给自己听的，你别应。”',
          styleValue: '给出时间不承诺永远在场',
        },
        {
          id: 'pack-away-lamp',
          label: '“先把灯收起来。等我们能分开‘想留下’和‘怕空着’，再谈。”',
          tone: 'calm',
          reply: '她轻轻点头，吹熄了灯。黑暗里她的声音反而稳了些：“收起来，今晚会更空。可一直点着，就是把害怕推给你。”你听见她把灯收进布袋的声音，“暂停不是抛下。我只是……想把问题看完整，再看你。”',
          styleValue: '暂停区分想留与害怕',
        },
      ],
      middle: '河风把岸边的灯吹得明明灭灭。温陷抱着那个布袋，把两种代价摆在长椅上，像摆两盏灯：“她需要可确认的回来，你需要不被象征物绑住。”她顿了顿，改口，“——是我需要。别替我客气。现在选：给一个有限的承诺，还是另想一种不用灯来判断感情的方式？”',
      secondChoices: [
        {
          id: 'promise-next-contact',
          label: '“我今天只能承诺下一次联系，承诺不了永远在场。”',
          tone: 'calm',
          reply: '温陷从袋里取出灯，在灯座底下写了一个很小的日期：“短承诺，要反复面对不确定。”她把日期给你看，“但它是真的。”她吹了吹那个字，“我不能要求一盏灯替未来担保。一个日期就够了，真的。”',
          styleValue: '有限承诺不替未来担保',
        },
        {
          id: 'separate-lamp-from-love',
          label: '“灯你留着。但别拿它判断我爱不爱你——这个，直接问。”',
          tone: 'secret',
          reply: '她没有点灯，只把灯抱在怀里：“留着它，我有个念想。”她低下头，“也多一份提醒：不许拿明暗当试卷。”再抬眼时她眼睛亮亮的，“那我现在问一次——你在吗？”你说在。她笑了：“看，比灯准。”',
          styleValue: '保留象征不用明暗审判',
        },
      ],
      closing: '灯最后还是收进了布袋。分别前温陷把布袋的绳结打了又解，解了又打：“以前我给很多人留过灯。”她终于把结打好，“留到最后，学会的第一件事是别把灯塞给别人。”她转身走进巷子，“下次联系，按约定的来。我不提前点亮它。”',
    },

    reconciliation: {
      title: '让灯火不再替人发问',
      location: '幻想夜市 · 无名花灯棚',
      opening: '温陷把那盏没署名的灯放在两人中间，火折子压在灯座下，没点：“我把‘怕空着’压在你身上，让你用留下来证明我值得被留。”她深吸一口气，“对不起。今晚我还是想要确定——这一点我不装。但确定不该再由你来供电。”',
      firstChoices: [
        {
          id: 'listen-before-relighting',
          label: '“先听我说那段压力，不急着把空灯点回去。”',
          tone: 'calm',
          reply: '温陷把火折子推到一边，双手抱住膝盖：“你说，我听。”等你说完，她安静了很久，久到河对岸又熄了一盏灯：“灯不亮的晚上，我得自己受。”她声音很低，“修复要是只追求安心，就又会把你推去填空。这个错，我犯过一次，记住了。”',
          styleValue: '先听压力不急着补空位',
        },
        {
          id: 'light-with-off-switch',
          label: '“一起点一盏新灯，写上‘可熄灭’。把不确定留在约定里。”',
          tone: 'warm',
          reply: '她擦亮火折子，火苗起来的时候她特意把灯罩留了一条缝：“它给我温度，也能随时熄。”她把“可熄灭”三个字写在灯座上，笔迹很轻，“你愿意一起维护它。”她抬眼，“但不负责永远供电。这条写明了，我才敢点。”',
          styleValue: '共同点灯允许随时熄灭',
        },
      ],
      middle: '长椅上只剩一支笔和一枚灯。先听，空白就继续存在；先点灯，安心回来得快，误读的风险也大。温陷没催你选，只把笔递过来：“以后怎么确认，才不让灯火替我们发试卷？这次答案你写，我不改。”',
      secondChoices: [
        {
          id: 'ask-directly',
          label: '“每次想确认就直接问。不用灯火，不用迟到，不用试卷。”',
          tone: 'bold',
          reply: '温陷看着你写下“直接问，接受答案”，轻声念了两遍：“被拒会疼，但比猜清楚。”她把纸条折好收进袖袋，“你也可以说‘不知道’。”她顿了顿，“‘不知道’我不会判成离开。这三个字以后受保护。”',
          styleValue: '直接询问接受真实答案',
        },
        {
          id: 'set-return-window',
          label: '“约一个固定的回来看灯时间。临时缺席只需说一声。”',
          tone: 'calm',
          reply: '她点头，把时间写在灯座底下，和上次的日期并排：“固定时间会限制自由，但给‘回来’一个落脚处。”她退后一步看两行字，“说一声不是审讯。”她笑了笑，“解释到累，也不算负责——这条主要是写给我自己看的。”',
          styleValue: '固定回返允许简短说明',
        },
      ],
      closing: '临走时，温陷把那盏灯点亮，挂在桥栏最边上的位置：“不署名。”她退后一步端详，“谁路过都能借一点光。”河风吹得火苗直晃，她没去护，“晃就晃吧。它现在不归谁管，反而稳当。”',
    },
  },

takemehand: {
    secondDate: {
      title: '两枚铃之间',
      location: '幻想夜市 · 双人回声巷',
      opening: 'takemehand把两枚铃扣在桌上，一推到你面前：“这枚是想见你，这枚是想回家。”她自己先笑了，“别笑，夜市买的，老板说铃音能治已读不回——他骗我的，我试过。”她指尖点着两枚铃，“今晚先用哪枚？”',
      firstChoices: [
        {
          id: 'choose-return-time',
          label: '“先约好几点结束，剩下的时间不看钟。”',
          tone: 'calm',
          reply: 'takemehand把回家铃揣进兜里：“好。知道什么时候停，反而敢放心靠近。”她往前走了两步，回头，“准点结束不算撤退。我以前总觉得先走的人输——今天开始不算了。”',
          styleValue: '有边界地靠近',
        },
        {
          id: 'follow-the-lantern',
          label: '“不设结束点。走到哪盏灯想停，就停。”',
          tone: 'warm',
          reply: '“也行。”她把两枚铃都留在摊上，跟摊主说了声“寄存”，“今天不把未知当承诺。”走出一段她忽然停下，“但我想回家的时候会直接说。不拿消失当暗号——这句是还你的，你上次教我的。”',
          styleValue: '随心同行不失联',
        },
      ],
      middle: '灯桥把两条路照成一条。摊主追上来问要不要把“陪伴时长”换成积分，takemehand把兑换券撕了，撕完把纸屑仔细收进兜里：“照顾不是多待一小时。”她把桥栏上的灰抹掉一块，示意你坐，“真要确认的是——累了能不能说，想靠近时不用猜。”',
      secondChoices: [
        {
          id: 'say-needs-directly',
          label: '“我累了会直说。你想靠近，也请说出来。”',
          tone: 'warm',
          reply: 'takemehand点头，点得很用力：“惊喜会少一点。”她掰着手指算，“但我不必靠猜来证明自己被需要。”她忽然掏出手机，给你发了一条消息，就两个字：“在吗。”发送，抬头，“看，成本多低。以前我要编辑八遍。”',
          styleValue: '直说需求不猜谜',
        },
        {
          id: 'leave-space-for-silence',
          label: '“今晚留一点不解释的安静。想说的时候再说。”',
          tone: 'secret',
          reply: '“安静我接受。”她把桥上的灯调暗了一盏——其实就是伸手遮了遮，“拿安静罚人，不行。”她在你身边坐下，隔着一拳的距离，“留白可以是照顾。”她顿了顿，“前提是出口一直亮着。我就是那个出口，先自夸一下。”',
          styleValue: '留白但给出出口',
        },
      ],
      closing: '收摊时摊主把两枚铃还回来，说寄存费免了，祝你们铃音常响。takemehand把“想回家”那枚塞给你，自己留了“想见你”：“各管各的，别搞混。”她晃了晃自己那枚，没摇响，“今天不用它。今天已经在见了。”',
    },

    conflict: {
      title: '同步状态之外',
      location: '幻想夜市 · 关系灯牌街',
      opening: '系统突然给你们挂上“伴侣同步状态”：一个人在线，另一个人的灯也跟着亮。灯牌街的游客都在回头看。takemehand盯着那块牌子，灯正好在她脸上明明灭灭：“这做得像监控。”她没动，声音低下去，“我在老区被人这样跟过一次。你想公开，我不怪你。但我想先问清楚——这不是谁更爱谁的问题。”',
      firstChoices: [
        {
          id: 'disable-sync-first',
          label: '“先关掉同步。公开到什么范围，都同意了再开。”',
          tone: 'calm',
          reply: '“保护隐私，也意味着别人会继续猜。”takemehand踮脚按下关闭键，灯牌暗下去的那一刻她肩膀松了，“误解我来扛。”她拍拍手上的灰，“但‘被看见’的风险，不该你替我承担。刚才那一瞬间，你是替我挡的。我记着了。”',
          styleValue: '先确认边界再公开',
        },
        {
          id: 'limit-visible-status',
          label: '“保留同步，但可见内容只显示‘在场’两个字。”',
          tone: 'bold',
          reply: '“这不是折中，是把公开缩到我们都受得了。”takemehand盯着简化后的灯牌看了半天，“还是会有人解读。”她撇撇嘴，“至少他们读不到我们的对话。”她拽了拽你袖子，“两个字挺好的。‘在场’——比‘恋爱中’诚实。”',
          styleValue: '有限公开保留自主',
        },
      ],
      middle: '灯牌熄了半边，系统还在固执地弹“请选择公开程度”。takemehand抬手把提示框划掉，笑得很轻：“看，连不公开都要写说明。”她在台阶上坐下，“分歧不在牌子——在我们愿不愿意让外界替这段关系起名字。”',
      secondChoices: [
        {
          id: 'pause-with-return-time',
          label: '“暂停十分钟，各自想清楚，按点回来谈。”',
          tone: 'calm',
          reply: '“同意。但暂停必须有回程。”她把手机倒计时设成十分钟，屏幕朝上放在两人中间，“不追着问是尊重。”她盯着跳动的数字，“没有回程，那叫悬置。我悬置过别人，知道那滋味。”',
          styleValue: '暂停有时限再沟通',
        },
        {
          id: 'write-boundaries-now',
          label: '“现在就写：三条可见，三条不可见。写完再定。”',
          tone: 'secret',
          reply: '“写下来冷一点，但好过靠气势赢。”takemehand从兜里摸出那张没扔的兑换券，翻到背面当草稿纸，“哪条让谁不舒服就重写。”她把笔塞给你，“不拿沉默盖章。我盖过，那章糊了。”',
          styleValue: '把不安写成具体规则',
        },
      ],
      closing: '灯牌街的人流散了。系统最后弹了一次同步邀请，takemehand看了你一眼，你没动，她也没动，提示框自己超时消失了。她笑了：“看，不回答也是一种回答。”她把“在场”两个字的截图存了下来，“这张归我。灯牌撤了，图还在。”',
    },

    reconciliation: {
      title: '回程有灯',
      location: '下线后 · 空白大厅',
      opening: '下线后的空白大厅只留一张双人桌。takemehand把那天的争执记录摊开，纸角已经被她捻得起了毛：“公开会被注视，保留会被猜测。”她没抬头，“但真正要道歉的是这个——我拿消失当退场。灯一关，人没了，留你一个人猜。”她终于抬眼，“不用一句‘没事’盖过去。今晚你尽管问。”',
      firstChoices: [
        {
          id: 'set-check-in-window',
          label: '“约好可见范围，也约好忙的时候只发一个‘在’。”',
          tone: 'calm',
          reply: '“少一点即兴，但没人被迫猜。”takemehand写下这条，写完自己先读了一遍，“一个‘在’字不是报备。”她的笔尖在纸上点了一下，“是告诉你，门还开着。”她把纸转过来，“我以前总把门摔上，还奇怪别人为什么不敲。”',
          styleValue: '低负担报平安',
        },
        {
          id: 'keep-private-signal',
          label: '“不设固定格式。需要空间的时候，明确说出来就行。”',
          tone: 'warm',
          reply: '“自由更像自由。”她把事先准备的模板划掉，划得很干脆，“也更考验我们不把沉默读成答案。”她吸了口气，“这份不确定我愿意扛。但我会提前说——‘我在退回自己’。就这六个字，练习了一路。”',
          styleValue: '自由靠近清楚退开',
        },
      ],
      middle: '纸分成两栏：能提前说的事，不能替对方决定的事。takemehand的字在第二栏明显慢下来。她没要求你立刻相信，只问：“下次我需要退开，怎么通知，才不会把猜的成本全丢给你？”',
      secondChoices: [
        {
          id: 'use-lantern-signal',
          label: '“用一盏蓝灯表示需要空间。亮着不追问，灭了再联系。”',
          tone: 'secret',
          reply: '“具体到颜色，浪漫值下降，可靠值上升。”takemehand真从包里摸出一盏小蓝灯，放在桌角，自己都愣了，“……我什么时候买的？”她把灯点亮，又吹熄，再点亮，“我会先亮灯。不再把失联伪装成神秘感——神秘感是灯，失联是黑。两回事。”',
          styleValue: '用信号保护彼此空间',
        },
        {
          id: 'name-time-directly',
          label: '“不设暗号，直接说：‘今晚不聊，明晚回来’。”',
          tone: 'bold',
          reply: '“这要求我承认自己在退开，而不是把决定丢给你猜。”takemehand点头，试着说了一遍：“今晚不聊，明晚回来。”说完她松了口气，“诚实会刺一下。”她揉了揉心口，“但不会留一整夜的回声。回声最熬人，我知道。”',
          styleValue: '直接说明退开时限',
        },
      ],
      closing: '约定写完，takemehand把纸折成很小的方块，没给你，自己收着：“我拿着。弄丢了就再来找你写一份。”走到大厅门口，她回身挥挥手，“别送我。门在那边，我认得路——这次走门，不走窗。”',
    },
  },

  xilufei: {
    secondDate: {
      title: '换皮慢游',
      location: '幻想夜市 · 无害戏法巷',
      opening: '希露菲拿着一张管理员券在你面前晃：“夜市特供版，只许改路牌，不许踢人——他们把我研究得很透彻。”她把券拍在桌上，“今晚可以把这条巷子改成任何名字。但我先问：你要一场热闹的骗局，还是一段不用演的散步？先声明，摊主买了保险，我没买。”',
      firstChoices: [
        {
          id: 'play-safe-prank',
          label: '“把路牌改成最夸张的假公告，再一起看大家拆穿。”',
          tone: 'bold',
          reply: '希露菲眼睛一亮，券已经按上了路牌：“好，骗局从第一秒就声明无害。”她三两下把巷子改名“4945区官方指定求婚圣地”，退后欣赏，“你负责笑，我负责在有人当真时立刻撤牌。”顿了顿，“……刚才有个路人当真了，我去去就回。”',
          styleValue: '一起胡闹及时收手',
        },
        {
          id: 'walk-no-costume',
          label: '“券先放下。陪我不戴面具走完这条巷子。”',
          tone: 'warm',
          reply: '“这难度也太高了。”希露菲把券塞回摊位，动作慢得像在割肉，“不靠戏法还愿意跟我走……”她跟上来，手都不知道往哪放，“老区的教程里绝对漏了这一章。我说话算话——今晚换皮次数，零。”',
          styleValue: '不演身份认真相处',
        },
      ],
      middle: '巷尾的镜子把你们的脸换成随机称号。你头顶挂着“老实人”，她头顶挂着“危险分子”。希露菲没急着按回去：“好玩的边界不是没人受伤。”她指着镜子里自己的称号，“是有人喊停的时候，戏法真的会停。”她转头看你，“今晚你来定，我们留哪一层真话？”',
      secondChoices: [
        {
          id: 'name-one-truth',
          label: '“留一条不改名的真话：我今天想跟你慢慢走。”',
          tone: 'warm',
          reply: '镜子里的称号闪了闪，她头顶那四个字忽然变成了“慢慢走”。希露菲愣了一下，伸手把那块镜子锁上：“……真话保住了，戏法反而有地方落脚。”她别开脸，“我可以继续换皮。但不拿你的认真当道具。这句不改名。”',
          styleValue: '真话优先再玩花样',
        },
        {
          id: 'set-play-exit',
          label: '“继续玩，但每轮结束问一次：要不要退出。”',
          tone: 'calm',
          reply: '“会打断节奏，但不会把退出变成扫兴罪。”希露菲点开计时器，动作利落，“我喜欢刺激。”她把计时器挂在你手腕上，“但不喜欢把喜欢的人困在剧情里。计时器归你管，喊停的权力也归你——这是今晚唯一不改名的规则。”',
          styleValue: '玩得尽兴也能退出',
        },
      ],
      closing: '最后一块路牌恢复原色。希露菲没带走那张管理员券，只从摊位上撕了枚贴纸拍在你手背：“‘可暂停’。送你的。”她退后一步，张开双臂转了一圈，“看，今晚零事故。”贴纸在路灯下反着光，“老区的我会觉得今晚无聊死了。”她笑了，“老区的她不懂。”',
    },

    conflict: {
      title: '悬念不是失联',
      location: '幻想夜市 · 三岔路牌口',
      opening: '希露菲约你来夜市，人到场时只找到三张互相矛盾的路牌：“八点见”“别找我”“跟上来”。你站了十分钟，他才从屋檐后探出头，脸上还挂着得意的笑——看到你的表情，那笑一点点收了：“……不好玩吗。”他跳下来，“我以为这叫悬念。你说这叫让你一个人猜。”他把三张牌收拢，“我听见你说什么了。现在换你说，我听着，不插嘴。”',
      firstChoices: [
        {
          id: 'cancel-mystery',
          label: '“今天取消悬念。直接告诉我：想见，还是想独处。”',
          tone: 'calm',
          reply: '“直接会少掉我最爱的花活。”希露菲把三张路牌叠好，码齐，像交还道具，“但我的乐趣，不该由你的不安买单。”他深吸一口气，“现在我想见你——也需要一小时独处。两句都是真的。”他举起手，“这次是明牌，没有第四张。”',
          styleValue: '把惊喜和失联分开',
        },
        {
          id: 'set-surprise-window',
          label: '“惊喜保留，但给我时间窗。超时按未赴约处理。”',
          tone: 'bold',
          reply: '“约会版安全绳。”希露菲笑了一下，用路牌在地上画了一个框，“刺激还在框里。”他拍拍手上的土，“代价是我不能临时改剧本，也不能怪你先走。”他把框描深，“超时你就走，走了算我的。这条刻这儿了。”',
          styleValue: '允许惊喜但不耗等待',
        },
      ],
      middle: '雨飘进来，三张路牌被打湿，字迹糊成一片。希露菲难得没去接那些牌，就任它们湿着：“你不是反对我有自己的空间，我也不是要你永远配合。”他抹了把脸上的雨水，“我们争的是——没说清楚的后果，谁来扛。以前都是你扛。我看清了。”',
      secondChoices: [
        {
          id: 'pause-and-return',
          label: '“各自离开二十分钟。回来只谈边界，不审问动机。”',
          tone: 'calm',
          reply: '“我会带走一半想解释的冲动。”希露菲看着钟，把剩下那半也咽了回去，“二十分钟后回来。”他走出两步，回头，“这次是真的回头——你看，我人在。改主意我也明说，不留谜语。”',
          styleValue: '暂停二十分钟再面对',
        },
        {
          id: 'talk-with-lines',
          label: '“现在谈清楚三条底线。今晚还能继续，但不许再临时消失。”',
          tone: 'secret',
          reply: '“继续玩，得先把地板铺好。”希露菲把湿透的路牌翻过来，背面朝上，递给你一支笔，“约束我接受。”他看着你写，“只是不保证每次都显得可爱。”他顿了顿，“比如现在，我就不可爱，但我在。”',
          styleValue: '先画底线再继续',
        },
      ],
      closing: '雨停了。三张糊掉的路牌被希露菲立在墙边，他说留着，当耻辱柱。走出巷口时他忽然说：“今天的悬念没成功。”他把手插在兜里，走在你旁边，半步不离，“但你在原地等了我十分钟。”他看着前方，“老区没人等过我。这个比悬念厉害。”',
    },

    reconciliation: {
      title: '无害体验券',
      location: '下线后 · 旧登录页后台',
      opening: '下线后的旧登录页只剩一个“重新进入”按钮。希露菲把那张糊掉的三路牌压在按钮下面，自己盘腿坐在地上：“我道歉——不是因为你没玩懂，是我把失联的风险推给了你。”他拍拍身边的地板，示意你坐，“你要求明确，也确实让渡了一部分惊喜。今晚不谈谁对谁错，谈怎么改。我带了道具。”',
      firstChoices: [
        {
          id: 'make-window-promise',
          label: '“惊喜保留，但先给开始时间和最晚结束时间。”',
          tone: 'calm',
          reply: '“好玩要有边框。”希露菲从兜里掏出粉笔，在地板上画了一个方框，又描了一圈，“我失去临时消失的爽感。”他把粉笔头弹进框里，“你得到不用守着谜语等的余地。”他指指那个框，“以后我的剧本，都在这里面上演。框外算事故。”',
          styleValue: '给惊喜装上安全边框',
        },
        {
          id: 'choose-direct-days',
          label: '“约会日说清楚。其他时候，剧本你自由换。”',
          tone: 'warm',
          reply: '“固定的是见面，不是我的脑洞。”希露菲点头，点得很郑重，“你不用每天验收我。”他掰着手指，“我也不拿偶发失联证明自由。”他忽然笑了，“说人话就是——约会日我是你的人，其他日子我是我的鬼。”',
          styleValue: '固定见面自由换剧本',
        },
      ],
      middle: '“重新进入”按钮亮了又灭，像在催你们立刻恢复原样。希露菲盯着它，没按：“修复不是把我变无趣，也不是你学会忍。”他把按钮用路牌盖住，“是让惊喜只发生在两个人都扛得住的范围里。这句子我想了一路，比我的任何剧本都难写。”',
      secondChoices: [
        {
          id: 'use-stop-word',
          label: '“设一个停演词。任何一方说出口，立即退出剧情。”',
          tone: 'secret',
          reply: '“停演词不是输，是安全出口。”希露菲把它写在券背面，字迹难得工整，“你不解释就暂停，我接受。”他把券递给你保管，“冷静后我会回来。”他顿了顿，“出口不当逃生洞用。这条管我，不管别人。”',
          styleValue: '停演不逃避复谈',
        },
        {
          id: 'try-small-surprise',
          label: '“先试一次十分钟的小惊喜。结束互相复盘感受。”',
          tone: 'bold',
          reply: '“小规模测试，这很你。”希露菲把计时器打开，眼睛又亮起来，“代价是浪漫会被复盘拆开。”他按着你肩膀让你坐好，“好处是，成不成功不用靠猜。”十分钟后，你手里多了一朵从登录页数据里长出来的花。他蹲在原地等评分，像等放榜。',
          styleValue: '小步试错共同复盘',
        },
      ],
      closing: '两张规则卡都没被称作永久契约。希露菲把粉笔和路牌收进包里，忽然想起什么，把“重新进入”按钮上的灰擦干净：“这按钮其实挺浪漫的。”他站起身，伸手拉你，“重新进入——不管上一局多烂。”他晃了晃你的手，“下一局，明晚八点开服。别迟到，我这次真的在。”',
    },
  },

  yyt: {
    secondDate: {
      title: '反方休息席',
      location: '幻想夜市 · 熄灯辩台',
      opening: 'yyT把两张辩论符卡扣在桌上：“一张反驳，一张停战。今晚没有观众，也没有裁判。”他抱臂看你，“我先把立场摆明：我反对‘约会必须温馨’这一普遍共识。现在，你要我陪你拆问题，还是陪你把问题放一晚？选哪个我都能找出三个论点。”',
      firstChoices: [
        {
          id: 'argue-gently',
          label: '“先让我把真正担心的事说完，再请你反驳。”',
          tone: 'calm',
          reply: 'yyT果然没抢话，手指在桌上敲着节拍等你讲完。“可以。完整陈述不是软弱——”他抽出反驳卡，“是给反驳一个准确靶心。”他顿了顿，把卡又放下，“……但今天靶心我先留着。你讲的时候，有一处哭腔，我听见了。先问那个。”',
          styleValue: '先听完整再锋利回应',
        },
        {
          id: 'rest-without-fix',
          label: '“今晚先不解决。陪我吃完这碗面再说。”',
          tone: 'warm',
          reply: '“把问题留到明天？反方意见——”yyT哼了一声，还是收起符卡，把面拖过来，“行。但不是逃避。”他挑起一筷子，“你要我陪，我就陪。陪的效率比反驳低，但……”他没说完，把第一筷子面夹到了你碗里。',
          styleValue: '允许暂停不撤销问题',
        },
      ],
      middle: '擂台的空观众席忽然亮起，系统提示“未完成争论将扣分”。yyT一脚踩灭提示灯：“扣分？谁的分。”他坐回来，“说正经的。关心不等于立刻修正你——这点我最近才同意。可要是我只会追问，你也不必把沉默贡献给我的胜负欲。我的胜负欲，自己养得起。”',
      secondChoices: [
        {
          id: 'set-return-time',
          label: '“约明晚再谈。今晚谁也别替谁下结论。”',
          tone: 'calm',
          reply: '“有回程的暂停，我接受。”yyT在符卡背面写下时间，字很冲，“代价是问题在夜里继续发热。”他把卡推过来，“好处是，我们不拿疲惫冒充共识。”他起身，“明晚我带反方意见，你带人。”',
          styleValue: '带回程时间的停战',
        },
        {
          id: 'name-harm-limit',
          label: '“继续谈，只谈事。一旦变成人身攻击，立刻停。”',
          tone: 'bold',
          reply: '“边界清楚，我就不用靠音量证明立场。”yyT把符卡翻面，在空白面写了两个字“对事”，“越线我认。”他抬眼，“‘我只是直说’不是免罪牌——这句话我抄下来贴墙上。反对有效，但我不反对。”',
          styleValue: '锋利但不伤及本人',
        },
      ],
      closing: '散场铃响，问题没判胜负。yyT把两张符卡一人一张分了，你拿到的是“停战”。他扬扬自己那张“反驳”：“别多想，不是我让着你。”他收拾东西往外走，“是今晚的比分不需要它。”走到门口他停下，“……面钱你付的。下次我请。这不是和解，是 AA 制原则。”',
    },

    conflict: {
      title: '公开不是证明',
      location: '幻想夜市 · 自动投屏擂台',
      opening: '夜市的擂台自动把你们的分歧投上大屏幕，围观的人开始起哄。yyT站在屏幕前面，手放在开关上，却没按：“我习惯把问题摆上台面，你习惯先护住两个人的空间。”起哄声更大了，他回头，“别把这说成谁更勇敢。上台有上台的代价，关门有关门的代价——你选，这次我不替你选。”',
      firstChoices: [
        {
          id: 'private-first',
          label: '“先关屏。在没有观众的地方，把分歧谈完。”',
          tone: 'calm',
          reply: '“关屏，外面的人会继续编故事。”yyT按下开关，屏幕黑掉，起哄声变成嘘声。他耸耸肩，“猜测我扛得住。”他走下擂台，台阶下才压低声音，“但你说得对。亲密不该被迫交给观众审判——观众连规则都不看。”',
          styleValue: '先守私域再谈立场',
        },
        {
          id: 'public-consent',
          label: '“大屏保留。但先约：只公开观点，不公开我们的细节。”',
          tone: 'bold',
          reply: '“这要求我把锋芒放在问题上，不拿你当论据。”yyT点头，转身面向屏幕，声音陡然亮起来——那是他上台的嗓音。三句话，他把分歧讲成了议题，全程没提你一个字。讲完他退回你身边，声音落回来：“公开还是会被误读。但至少，没拿关系当武器。”',
          styleValue: '公开观点不公开隐私',
        },
      ],
      middle: '屏幕把“支持”和“反对”染成两种颜色，连沉默都被判成选边。yyT抬手关掉音量，擂台上骤然安静：“我不要求你替我上台。”他看着你，“你也不能要求我把所有锋利收进私聊。那样我就不是我了。”他顿了顿，“所以得定下来——哪些边界，共享。”',
      secondChoices: [
        {
          id: 'pause-return-public',
          label: '“今晚的公开讨论先停。明天带着各自底线再定。”',
          tone: 'calm',
          reply: '“延期会错过一场漂亮的反击。”yyT收起话筒，收得很慢，显然心疼，“但错过不等于投降。”他把话筒递给你检查，“看，关了。我不愿意为一场胜负，让关系付隐私的账。”他顿了顿，“这场反击记入‘延期’，不记入‘放弃’。措辞很重要。”',
          styleValue: '暂缓公开保留回场权',
        },
        {
          id: 'continue-no-personal',
          label: '“继续。但谁都不许引用对方的私密话来赢。”',
          tone: 'bold',
          reply: '“这条我接——哪怕它拿走我最快的一把刀。”yyT从口袋里摸出一张记着私事的纸条，当着你的面撕了，“输掉技巧，不等于输掉立场。”纸屑落在擂台上，“再说，用私话赢来的掌声，听着像嘘声。”',
          styleValue: '不拿隐私换取胜利',
        },
      ],
      closing: '大屏最后只留下“分歧未决”四个字。yyT盯着那行字看了一会，忽然觉得顺眼：“‘未决’比‘已和解’诚实。”他跳下擂台，“你不是在拒绝我，我也不是在测试你。”他把手插进兜里，“散场吧。观众都走了，评委还在——评委是你。”',
    },

    reconciliation: {
      title: '章程背面',
      location: '下线后 · 章程背面大厅',
      opening: '下线后的章程背面大厅没有观众。yyT把那次投屏的记录打印件带来，撕成两份，一份推给你：“我拿我们的私密去证明立场，这个我道歉。”他没有移开视线，“你坚持关屏，也付过代价——错过反击，一个人受猜测。”他把笔放在两份纸中间，“两边都别装没损失。装了我跟你急。”',
      firstChoices: [
        {
          id: 'write-public-boundary',
          label: '“写清楚：哪些观点可以公开，哪些细节永远要双方同意。”',
          tone: 'calm',
          reply: 'yyT接过笔，写得很快，显然在脑子里打过草稿：“边界会让我少几句现成的狠话。”他写完，把纸转过来，“但公开反对从此不误伤你。”他在落款处签了名，笔锋很重，“清楚不是削弱——是把责任写在我自己名下。签字，画押，生效。”',
          styleValue: '公开前先取得共同同意',
        },
        {
          id: 'test-private-dispute',
          label: '“先在私下完成一次分歧演练，再决定上不上台。”',
          tone: 'warm',
          reply: '“演练？把恋爱做成训练赛——”yyT嗤了一声，却没有否决，“……行。但我会少一场即时胜负。”他活动了一下手腕，像运动员热身，“多一次看清你停在哪里的机会。说实话，你停的地方，我上次根本没看。”',
          styleValue: '先私下演练再上台',
        },
      ],
      middle: '他没用签名把道歉封存，而是把纸翻到背面，空白朝上：“以后还会有公开冲突，也会有我判断失误的时候。”他敲敲那张白纸，“修复得能处理下一次——不能只纪念这一次。纪念品救不了下一场。”',
      secondChoices: [
        {
          id: 'pause-word-for-debate',
          label: '“‘暂停上台’当停战词。说出口就先离场，约好时间再复谈。”',
          tone: 'secret',
          reply: '“离场不是被否决，是避免把怒气广播出去。”yyT写下回场时间，笔尖戳破了纸，“我会回来。”他把破了的纸抚平，“暂停不许被改写成‘你怕了’。谁敢这么解读，我亲自反驳——用公开渠道。”',
          styleValue: '离场停战按时复谈',
        },
        {
          id: 'two-channel-rule',
          label: '“公开反对保留。但结束后，必须私下互相确认感受。”',
          tone: 'bold',
          reply: '“公开私下，各走一条路。”yyT放下话筒——他真把夜市的话筒带来了，“我会问你受没受伤。”他把话筒关掉，“不等你先证明自己扛得住。你扛得住，我照样问。这条没有例外条款。”',
          styleValue: '公开争论私下确认',
        },
      ],
      closing: '章程背面多了一条新规定，字迹潦草，签名却一笔一划。yyT扣上笔帽：“这条限制我，也保护你。”他把那份撕开的记录折好，递给你一半，“我接受——关系不是我的扩音器。”他顿了顿，声音低下去，“扩音器只对陌生人用。你不是。”',
    },
  },

  avucii: {
    secondDate: {
      title: '无编号的一小时',
      location: '幻想夜市 · 河灯桥下休息桌',
      opening: 'AVUCII带来四张表：路线、餐点、备用路线，和一张“如果你突然想回家”。她把前三张摊开，最后一张压在手下，压着压着，自己先笑了：“你看，我连你想逃都做好了预案。”她把四张表拢起来，“今天二选一——按表陪你，还是把这一小时交给你安排？选后者的话，给我五分钟做心理建设。”',
      firstChoices: [
        {
          id: 'follow-her-plan',
          label: '“先按你的预案走。但每完成一项，问我一次还舒不舒服。”',
          tone: 'calm',
          reply: 'AVUCII点开清单，在第一项后面添了一栏“确认”：“效率会慢一点。”她打勾的动作停了一下，“但我听见的就是你，不只是进度。”第一项走完，她真的停下来看着你，“第一项完成。现在回答——不是走流程，我真问。”',
          styleValue: '按计划也持续询问',
        },
        {
          id: 'unplanned-hour',
          label: '“把表收起来。留一小时不编号，想去哪你选。”',
          tone: 'warm',
          reply: '“不编号我会焦虑。”AVUCII把笔放下，四张表叠好，码齐，塞进包里最深的夹层，“但焦虑不是你的任务。”她深吸一口气，指着最近的一盏灯，“我练习只选一盏灯——就去那。剩下的路，让它自己长出来。”',
          styleValue: '给计划留出无编号时间',
        },
      ],
      middle: '河灯桥下的系统不断生成“下一步”，AVUCII抬手逐条划掉，划到第七条时笑了：“原来陪你不是把所有风险消灭。”她把最后一栏留白，“真正要照顾的是——计划没覆盖到的时候，也有人能直接说停。比如你。比如现在，你可以试试。”',
      secondChoices: [
        {
          id: 'check-in-each-stop',
          label: '“每到一个摊子互问一次：想走想留，都可以改。”',
          tone: 'warm',
          reply: '“行程会变慢，但改变不用等到出问题。”AVUCII把改动栏留白，白得很彻底，“临时变更我接受。”她在空白处写了个小小的“可”字，“不叫失误。失误是没有这一栏——以前的我。”',
          styleValue: '慢一点但随时可更改',
        },
        {
          id: 'reserve-private-time',
          label: '“各留二十分钟独处，再回来共享最后一盏灯。”',
          tone: 'calm',
          reply: '“分开也算约会的一部分？”她认真记下，在“二十分钟”上画了圈，“好处是陪伴不会耗成义务。”她合上本子，“代价是我得信你会回来——而不是继续加任务。”她站起身，“二十分钟后，这盏灯下。我不设闹钟。……好吧我设了，但我不看。”',
          styleValue: '保留独处再回来相见',
        },
      ],
      closing: '散场时四张表只剩一张空白页。AVUCII在页眉写下“吃饭、休息、想回家”，写完把笔一收：“今天没有完美交付。”她把那张纸折好，放进你口袋，“但有人被照顾到了。而且——”她拍拍空了的公文包，“不是靠替谁接管。包都轻了。”',
    },

    conflict: {
      title: '交接前不能约会',
      location: '下线后 · 未完成交接台',
      opening: '下线后的交接台把你们的晚饭标成了“待处理事项·三级”。AVUCII坐在台前，手指悬在键盘上，晚饭在旁边一点点凉下去。你站到她旁边，她才开口，眼睛还盯着屏幕：“最后一件。”你指出上次、上上次，都是最后一件。她的手停住了：“……这不是谁不在乎谁。是责任和相处时间，撞在一起了。你先说，我听着——我不记会议纪要。”',
      firstChoices: [
        {
          id: 'split-responsibility',
          label: '“把必须处理的事项列出来。剩下的，今晚不接。”',
          tone: 'calm',
          reply: '“列清楚会逼我承认：有些事只是我不敢放手。”AVUCII把事项一条条过，划掉一半，划到第三条时咬了咬牙，“晚饭会晚。”她划出截止线，划得很重，“但边界不再无限后移。这线要是再让，你拿晚饭泼我。”',
          styleValue: '先划截止线再承担',
        },
        {
          id: 'leave-the-desk',
          label: '“现在离开交接台。没做完的，明天处理。”',
          tone: 'bold',
          reply: '“离开保住了今晚。”AVUCII盯着屏幕看了十秒，按灭，动作像拔河，“但我会一路想着遗漏。”她把钥匙放回桌面，推得很远，“我不保证立刻放松。”她站起来，“但我承认——这也是一种选择。选你。记录在案。”',
          styleValue: '承认焦虑仍选择离开',
        },
      ],
      middle: '交接台没有催促声，只有一列列自动增长的空格，像永远填不完的坑。AVUCII挡在你和屏幕中间：“你要的是我在场，不是一个帮忙的位置。我想把事情做好，也不是拒绝你。”她抱着手臂，“但不能总让同一方让步。上次是我，这次轮到工作让。”',
      secondChoices: [
        {
          id: 'pause-and-return',
          label: '“各自休息三十分钟。之后只决定今晚还继不继续。”',
          tone: 'calm',
          reply: '“把目标缩小，我会觉得事情没被抛弃。”AVUCII设好回程提醒，设完把手机扣在台上，“暂停的焦虑我扛。”她看了眼凉掉的晚饭，“不转给你。……晚饭先热上，这个优先级，一级。”',
          styleValue: '缩小问题按时回来谈',
        },
        {
          id: 'write-help-boundary',
          label: '“现在写清：我能帮什么，不能替你决定什么。”',
          tone: 'secret',
          reply: '“这很不浪漫，但能防止帮忙变成接管。”AVUCII递出两栏纸，左边已经写好了她的部分，“我也要学会说‘不用你做’。”她咬着笔帽，“不把拒绝当失望。你拒绝我的时候……”她想了想，“我就当系统在维护。”',
          styleValue: '帮助有边界拒绝不受罚',
        },
      ],
      closing: '晚饭重新热过，交接台的屏幕黑着。AVUCII把未完成页夹回文件夹，明天的事明天再说。她端起碗，忽然停下：“今天的工作，产出为零。”她扒了一口饭，“但这个，”她指指碗里，“五星好评。人的指标，比事的指标难达标——我练。”',
    },

    reconciliation: {
      title: '最后一行',
      location: '下线后 · 最后一行登记室',
      opening: '最后一行登记室没有印章。AVUCII把一张表放在台面上，左边写着她的代价，右边写着你的，字迹工整，只有标题是手抖的：“我把你的陪伴当成可调度资源，这个我道歉。”她抬起头，“你想要我停下——这个不用道歉。”她把笔放在两行中间，“今天登记的不是事项。是我们。”',
      firstChoices: [
        {
          id: 'coauthor-rest-rule',
          label: '“一起写一条：约会先有时限，紧急事项要先征得同意。”',
          tone: 'calm',
          reply: 'AVUCII写下标题，笔锋比平时慢：“规则会减少临时救火的自由。”她写完，把笔递给你，示意你补后半句，“保护我们不把爱变成加班。”她看着两人各写一半的纸，“要改，双方都能提。不由我单方面升级——以前我升过级，你没收到通知。”',
          styleValue: '先约时间再处理紧急事',
        },
        {
          id: 'practice-unplanned-night',
          label: '“先试一晚无清单约会。结束后复盘哪里不安。”',
          tone: 'warm',
          reply: '“试一晚，我的不安会暴露，你也不必立刻签长期方案。”AVUCII把表格收起来，收了三次才收进去，“我可以不舒服。”她拍拍那个放表的抽屉，“但不把不舒服变成你的任务。它住这儿，有编制，不外包。”',
          styleValue: '用一次实践替代保证',
        },
      ],
      middle: '她把旧清单装进抽屉，没销毁，也没置顶，就让它躺在最普通的格子里。AVUCII说：“修复不是把‘负责’从我身上拿走——是让我负责自己的选择。”她关上抽屉，“同时，你有拒绝帮忙的完整权利。完整的意思，是连愧疚都不必附带。”',
      secondChoices: [
        {
          id: 'use-emergency-consent',
          label: '“‘紧急’必须两个人确认。没确认的，明天再排。”',
          tone: 'secret',
          reply: '“这会让我错过一些立刻补洞的机会。”AVUCII点头，在登记簿上写下这一条，编号是手写的“001”，“但我也能得到一个晚上——不把所有漏洞都当我的责任。”她退后一步看那行字，“世界少了我连夜补的洞，转得动。我验证过……好吧，没验证过，但今晚开始验证。”',
          styleValue: '紧急事项先取得同意',
        },
        {
          id: 'scheduled-no-work-night',
          label: '“每周留一晚不接交接。谁焦虑谁先说，不用装没事。”',
          tone: 'warm',
          reply: '“固定休息限制我的弹性，但给焦虑一个不用争抢的出口。”AVUCII翻开日历，把那一晚的格子涂满，涂完在边上写了个小小的“人”字，“我会来。”她合上日历，“不把你排进待办。你从来就不是待办——你是我列错栏的那一项，现在归位。”',
          styleValue: '固定休息不把人列待办',
        },
      ],
      closing: '登记簿的最后一行仍然空着。AVUCII没有填，只在行尾点了一个很小的点：“这行留着。”她合上本子，“表示以后还会有新情况。不表示修复失败。”她把钥匙放在两人中间，“登记室我锁了。下次开门，一起来。”',
    },
  },
} satisfies RomanceAfterStoryScripts
